import React, { useState, useMemo, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
//import { ChevronDown, Plus, Trash2 } from "lucide-react";
import { ChevronDown, Plus, Trash2, MapPin } from "lucide-react";
import { postApi, getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import toast from "react-hot-toast";
import FormQuestionInput, { RequiredMark } from "./components/QuestionInput";
import FormQuestionTable, { TableManager } from "./components/QuestionTable";
import PopupCard from "../../../Auth/PopupCard";
import MandatoryErrorsModal from "./components/MandatoryErrorsModal";
import {
  buildQuestionTree,
  formatSerialDisplay,
  formatSerialNumber,
  isNumberedType,
  sortByOrderIndex,
} from "./components/serialNumberUtils";
export const QuestionFormScope1234 = ({
  questions: questionsProp,
  sectionId,
  subSectionId,
  sections = [],
  subsectionsBySection = {},
  answers: controlledAnswers,
  setAnswers: controlledSetAnswers,
  answersBySubsection = {},
  formattedAnswersBySubsection = {},
  onFormattedAnswersChange,
  employeeId,
  userId,
  standardFormAllotmentId,
  templateId,
  projectId,
  fillFrom = false,
  onPrevious,
  onNext,
  canGoPrevious = false,
  canGoNext = false,
}) => {
  // debugger;
  // console.log(questionsProp, "allquestionwithsubsection")

  const [localAnswers, setLocalAnswers] = useState({});
  const [tableDefs, setTableDefs] = useState({});
  const [optionsCache, setOptionsCache] = useState({});
  const answers = controlledAnswers ?? localAnswers;
  const setAnswers = controlledSetAnswers ?? setLocalAnswers;
  const [payloadState, setPayloadState] = useState({
    UserId: userId,
    standardFormAllotmentId,
    templateId,
    projectId,
    sectionsData: [],
  });
  const [savePopup, setSavePopup] = useState({
    open: false,
    message: "",
    moveNext: false,
  });
  const [errorPopup, setErrorPopup] = useState({
    open: false,
    title: "",
    message: "",
  });
  const [mandatoryErrorPopup, setMandatoryErrorPopup] = useState({
    open: false,
    message: "",
    errors: [],
  });
  const [submitConfirmPopup, setSubmitConfirmPopup] = useState(false);
  const savePopupTimeoutRef = useRef(null);
  const errorPopupTimeoutRef = useRef(null);

  useEffect(() => {
    if (!errorPopup.open) return;
    if (errorPopupTimeoutRef.current)
      clearTimeout(errorPopupTimeoutRef.current);
    errorPopupTimeoutRef.current = setTimeout(() => {
      setErrorPopup({ open: false, title: "", message: "" });
    }, 3000);
    return () => clearTimeout(errorPopupTimeoutRef.current);
  }, [errorPopup.open]);

  const getSubsectionStateKey = (targetSectionId, targetSubSectionId) =>
    `${targetSectionId || ""}:::${targetSubSectionId || ""}`;

  useEffect(() => {
    setPayloadState((prev) => ({
      UserId: userId,
      standardFormAllotmentId,
      templateId,
      projectId,
      sectionsData: (sections || []).map((section) => {
        const sectionSubsections =
          subsectionsBySection?.[section.sectionId] || [];
        const previousSection = (prev?.sectionsData || []).find(
          (item) => item.sectionId === section.sectionId,
        );

        return {
          sectionId: section.sectionId,
          subsectionsData: sectionSubsections.map((subsection) => {
            const targetSubSectionId = subsection.id || subsection._id;
            const previousSubsection = (
              previousSection?.subsectionsData || []
            ).find((item) => item.subSectionId === targetSubSectionId);

            return {
              subSectionId: targetSubSectionId,
              answers: previousSubsection?.answers || [],
            };
          }),
        };
      }),
    }));
  }, [
    userId,
    standardFormAllotmentId,
    templateId,
    projectId,
    sections,
    subsectionsBySection,
  ]);

  // Normalize and Deduplicate
  // const questionsList = useMemo(() => {
  //     if (!questionsProp) return [];
  //     let flat = [];
  //     if (Array.isArray(questionsProp)) {
  //         questionsProp.forEach((q) => {
  //             if (q?.questions) flat.push(...q.questions);
  //             else if (q?.questionId) flat.push(q);
  //         });
  //     }

  //     // Smart Deduplication: Prefer objects with displayCondition
  //     const uniqueMap = new Map();
  //     flat.forEach(q => {
  //         const existing = uniqueMap.get(q.questionId);
  //         if (!existing) {
  //             uniqueMap.set(q.questionId, q);
  //         } else {
  //             // If existing doesn't have condition but new one does, replace it
  //             if ((!existing.displayCondition || existing.displayCondition.length === 0) &&
  //                 (q.displayCondition && q.displayCondition.length > 0)) {
  //                 uniqueMap.set(q.questionId, q);
  //             }
  //         }
  //     });

  //     return Array.from(uniqueMap.values());
  // }, [questionsProp]);

  // Replace your existing questionsList useMemo with this:
  const questionsList = useMemo(() => {
    if (!questionsProp) return [];
    let flat = [];

    if (Array.isArray(questionsProp)) {
      questionsProp.forEach((item) => {
        // Handle division structure (new format)
        if (item?.questions && Array.isArray(item.questions)) {
          flat.push(...item.questions);
        }
        // Handle direct question objects (old format)
        else if (item?.questionId) {
          flat.push(item);
        }
      });
    }

    // Smart Deduplication: Prefer objects with displayCondition
    const uniqueMap = new Map();
    flat.forEach((q) => {
      const existing = uniqueMap.get(q.questionId);
      if (!existing) {
        uniqueMap.set(q.questionId, q);
      } else {
        if (
          (!existing.displayCondition ||
            existing.displayCondition.length === 0) &&
          q.displayCondition &&
          q.displayCondition.length > 0
        ) {
          uniqueMap.set(q.questionId, q);
        }
      }
    });

    return Array.from(uniqueMap.values());
  }, [questionsProp]);

  const questionTree = useMemo(
    () => buildQuestionTree(questionsList),
    [questionsList],
  );

  const SUFFIX_SEP = ":::";

  const getMultiselectDependency = (
    field,
    currentAnswers,
    tripIndex = null,
    optionSuffix = null,
    extraFields = [],
  ) => {
    if (!field.displayCondition) return null;

    const multiselectDep = field.displayCondition.find((cond) => {
      if (cond.operator !== "exists") return false;
      let triggerField = questionsList.find(
        (q) => q.questionId === cond.triggerQuestionId,
      );

      // If not found in main list, check extra fields (e.g., table row fields)
      if (!triggerField && extraFields && extraFields.length > 0) {
        triggerField = extraFields.find(
          (q) =>
            q.fieldId === cond.triggerQuestionId ||
            q.questionId === cond.triggerQuestionId,
        );
      }

      return (
        triggerField?.questionType === "multiselect" ||
        triggerField?.fieldType === "multiselect"
      );
    });

    if (!multiselectDep) return null;

    const multiselectFieldId = multiselectDep.triggerQuestionId;

    // --- HIERARCHICAL LOOKUP ---
    let selectedItems;
    if (currentAnswers[multiselectFieldId]) {
      selectedItems = currentAnswers[multiselectFieldId];
    }

    if (selectedItems === undefined) {
      let s = optionSuffix;
      while (selectedItems === undefined) {
        if (tripIndex !== null && s)
          selectedItems =
            currentAnswers[`${multiselectFieldId}_trip_${tripIndex}_${s}`];
        if (selectedItems === undefined && s)
          selectedItems = currentAnswers[`${multiselectFieldId}_${s}`];
        if (selectedItems === undefined && tripIndex !== null)
          selectedItems =
            currentAnswers[`${multiselectFieldId}_trip_${tripIndex}`];
        if (selectedItems === undefined)
          selectedItems = currentAnswers[multiselectFieldId];

        if (selectedItems !== undefined || !s || !s.includes(SUFFIX_SEP)) break;
        s = s.substring(0, s.lastIndexOf(SUFFIX_SEP));
      }
    }

    if (!Array.isArray(selectedItems) || selectedItems.length === 0) {
      return null;
    }

    return multiselectFieldId;
  };

  const evalCondition = (cond, context = {}) => {
    if (!cond) return true;

    if (
      cond.questionId === "scope3_categories_non_capital_goods_table" ||
      cond._id === "scope3_categories_non_capital_goods_table"
    ) {
      const currentAnswers = context.currentAnswers || answers;

      const getValAnySuffix = (triggerId) => {
        if (currentAnswers[triggerId] !== undefined)
          return currentAnswers[triggerId];
        const key = Object.keys(currentAnswers).find(
          (k) =>
            k === triggerId ||
            k.startsWith(`${triggerId}_`) ||
            k.startsWith(`${triggerId}${SUFFIX_SEP}`),
        );
        return key ? currentAnswers[key] : undefined;
      };

      const scope3First = getValAnySuffix("scope3_first");
      const scope3Categories = getValAnySuffix("scope3_categories");

      const firstExists =
        scope3First !== undefined && scope3First !== null && scope3First !== "";
      if (!firstExists) return false;

      const categoriesList = Array.isArray(scope3Categories)
        ? scope3Categories
        : scope3Categories
          ? [scope3Categories]
          : [];
      return !categoriesList.includes("capital_goods");
    }

    const triggerId = cond.triggerQuestionId || cond.triggerFieldId;
    const currentAnswers = context.currentAnswers || answers;

    // Logic fix: if this condition is for the parent that is currently repeating, it's satisfied
    if (context.repeatingParentId && triggerId === context.repeatingParentId)
      return true;

    // 1. If passed a Question Object (has displayCondition)
    if (cond.displayCondition) {
      const conditions = cond.displayCondition;
      if (!conditions || conditions.length === 0) return true;

      const logicalOp = (cond.logicalOperator || "AND").toUpperCase();
      const check = (c) => evalCondition(c, context);

      if (logicalOp === "OR") return conditions.some(check);
      return conditions.every(check);
    }

    // 2. If passed an Array of conditions (recursive case)
    if (Array.isArray(cond)) {
      return cond.every((c) => evalCondition(c, context));
    }

    // 3. Single Condition Object
    if (!cond.triggerQuestionId && !cond.triggerFieldId) return true;
    if (!cond.operator) return true;

    const triggerQuestionId = cond.triggerQuestionId || cond.triggerFieldId;
    const { operator, value: expected } = cond;
    let actual;

    // --- HIERARCHICAL LOOKUP ---
    // We look for the answer in this order:
    // 1. In rowData (if evaluating in a table)
    // 2. trip + suffix specific: qid_trip_0_optionVal
    // 3. suffix specific: qid_optionVal
    // 4. trip specific: qid_trip_0
    // 5. global: qid

    if (context.rowData && context.rowData.hasOwnProperty(triggerQuestionId)) {
      actual = context.rowData[triggerQuestionId];
    } else {
      const tripIdx = context.tripIndex;
      let s = context.optionSuffix;

      // --- HIERARCHICAL SUFFIX LOOKUP ---
      // If we are in a branch (e.g., individual:::air_travel),
      // first check the most specific key, then strip segments of the suffix.
      while (actual === undefined) {
        if (tripIdx !== null && s) {
          actual = currentAnswers[`${triggerQuestionId}_trip_${tripIdx}_${s}`];
        }
        if (actual === undefined && s) {
          actual = currentAnswers[`${triggerQuestionId}_${s}`];
        }
        if (actual === undefined && tripIdx !== null) {
          actual = currentAnswers[`${triggerQuestionId}_trip_${tripIdx}`];
        }
        if (actual === undefined) {
          actual = currentAnswers[triggerQuestionId];
        }

        if (actual !== undefined || !s || !s.includes(SUFFIX_SEP)) break;
        // Strip the last part of the hierarchical suffix
        s = s.substring(0, s.lastIndexOf(SUFFIX_SEP));
      }
    }

    if (operator === "exists") {
      let exists;
      if (Array.isArray(actual)) {
        exists = actual.length > 0;
      } else if (
        typeof actual === "number" ||
        (!isNaN(actual) && actual !== "")
      ) {
        exists = parseFloat(actual) > 0;
      } else {
        exists = actual !== undefined && actual !== null && actual !== "";
      }
      return expected ? exists : !exists;
    }

    // Standard comparisons
    if (Array.isArray(actual)) {
      if (operator === "eq") return actual.includes(expected);
      if (operator === "ne") {
        if (actual.length === 0) return false;
        return actual.some((val) => val !== expected);
      }
    }

    const actualVal = actual === undefined || actual === null ? "" : actual;
    if (operator === "eq") return actualVal == expected;
    if (operator === "ne") {
      if (
        actualVal === "" ||
        (Array.isArray(actualVal) && actualVal.length === 0)
      )
        return false;
      return actualVal != expected;
    }

    return true;
  };

  const buildQuestionInstanceKey = (
    questionId,
    tripIndex = null,
    optionSuffix = null,
  ) => {
    let qid = questionId;
    if (tripIndex !== null) qid += `_trip_${tripIndex}`;
    if (optionSuffix) qid += `_${optionSuffix}`;
    return qid;
  };

  const collectQuestionDescendantIds = (parentId, collected = new Set()) => {
    questionsList.forEach((child) => {
      if (
        child.displayCondition?.some(
          (condition) => condition.triggerQuestionId === parentId,
        )
      ) {
        if (!collected.has(child.questionId)) {
          collected.add(child.questionId);
          collectQuestionDescendantIds(child.questionId, collected);
        }
      }
    });

    return collected;
  };

  const getVisibleChildQuestions = (
    parentId,
    context = {},
    sourceAnswers = answers,
  ) => {
    return questionsList.filter((child) => {
      if (
        child.questionId === "scope3_categories_non_capital_goods_table" &&
        parentId === "scope3_first"
      ) {
        return evalCondition(child, {
          ...context,
          currentAnswers: sourceAnswers,
        });
      }

      // Explicitly prevent the non-capital goods table from rendering as a child
      // of the multiselect (1.1.1). It should only render via the fast-path above (as 1.2).
      if (
        child.questionId === "scope3_categories_non_capital_goods_table" &&
        parentId === "scope3_categories"
      ) {
        return false;
      }

      if (!child.displayCondition) return false;

      const parentConditions = child.displayCondition.filter(
        (condition) => condition.triggerQuestionId === parentId,
      );

      if (parentConditions.length === 0) return false;

      const logicalOp = (child.logicalOperator || "AND").toUpperCase();
      const isSatisfied = (condition) => {
        if (
          context.repeatingParentId &&
          condition.triggerQuestionId === parentId
        ) {
          return true;
        }

        return evalCondition(condition, {
          ...context,
          currentAnswers: sourceAnswers,
        });
      };

      if (logicalOp === "OR") {
        return parentConditions.some(isSatisfied);
      }

      return parentConditions.some(isSatisfied);
    });
  };

  const collectVisibleQuestionKeys = (
    parentId,
    context = {},
    sourceAnswers = answers,
    visibleKeys = new Set(),
  ) => {
    const visibleChildren = getVisibleChildQuestions(
      parentId,
      context,
      sourceAnswers,
    );

    visibleChildren.forEach((child) => {
      let childSuffix = context.optionSuffix;

      if (child.displayCondition) {
        const specificCondition = child.displayCondition.find(
          (condition) =>
            condition.triggerQuestionId === parentId &&
            condition.operator === "eq" &&
            typeof condition.value === "string",
        );

        if (specificCondition) {
          childSuffix = context.optionSuffix
            ? `${context.optionSuffix}${SUFFIX_SEP}${specificCondition.value}`
            : specificCondition.value;
        }
      }

      const multiselectTriggerId = getMultiselectDependency(
        child,
        sourceAnswers,
        context.tripIndex ?? null,
        childSuffix,
      );

      if (multiselectTriggerId) {
        let selectedItems = sourceAnswers[multiselectTriggerId];

        if (!selectedItems) {
          let suffixCursor = childSuffix;

          while (!selectedItems) {
            if (
              context.tripIndex !== null &&
              context.tripIndex !== undefined &&
              suffixCursor
            ) {
              selectedItems =
                sourceAnswers[
                  `${multiselectTriggerId}_trip_${context.tripIndex}_${suffixCursor}`
                ];
            }
            if (!selectedItems && suffixCursor) {
              selectedItems =
                sourceAnswers[`${multiselectTriggerId}_${suffixCursor}`];
            }
            if (
              !selectedItems &&
              context.tripIndex !== null &&
              context.tripIndex !== undefined
            ) {
              selectedItems =
                sourceAnswers[
                  `${multiselectTriggerId}_trip_${context.tripIndex}`
                ];
            }
            if (!selectedItems) {
              selectedItems = sourceAnswers[multiselectTriggerId];
            }

            if (
              selectedItems ||
              !suffixCursor ||
              !suffixCursor.includes(SUFFIX_SEP)
            ) {
              break;
            }

            suffixCursor = suffixCursor.substring(
              0,
              suffixCursor.lastIndexOf(SUFFIX_SEP),
            );
          }
        }

        (selectedItems || [])
          .filter((item) => item !== "")
          .forEach((itemValue) => {
            const itemSuffix = childSuffix
              ? `${childSuffix}${SUFFIX_SEP}${itemValue}`
              : itemValue;

            const questionKey = buildQuestionInstanceKey(
              child.questionId,
              context.tripIndex ?? null,
              itemSuffix,
            );

            visibleKeys.add(questionKey);

            const currentValue = sourceAnswers[questionKey];
            const hasChildDependents = questionsList.some((question) =>
              question.displayCondition?.some(
                (condition) => condition.triggerQuestionId === child.questionId,
              ),
            );

            if (
              (child.questionType === "number" ||
                child.questionId === "number_of_trip_select") &&
              parseInt(currentValue) > 0 &&
              hasChildDependents
            ) {
              Array.from(
                { length: Math.min(parseInt(currentValue), 100) },
                (_, index) => index,
              ).forEach((loopIndex) => {
                collectVisibleQuestionKeys(
                  child.questionId,
                  {
                    tripIndex: loopIndex,
                    optionSuffix: itemSuffix,
                    repeatingParentId: child.questionId,
                  },
                  sourceAnswers,
                  visibleKeys,
                );
              });
            } else {
              collectVisibleQuestionKeys(
                child.questionId,
                {
                  tripIndex: context.tripIndex ?? null,
                  optionSuffix: itemSuffix,
                  repeatingParentId: context.repeatingParentId || null,
                },
                sourceAnswers,
                visibleKeys,
              );
            }
          });

        return;
      }

      const questionKey = buildQuestionInstanceKey(
        child.questionId,
        context.tripIndex ?? null,
        childSuffix,
      );

      visibleKeys.add(questionKey);

      const currentValue = sourceAnswers[questionKey];
      const hasChildDependents = questionsList.some((question) =>
        question.displayCondition?.some(
          (condition) => condition.triggerQuestionId === child.questionId,
        ),
      );

      if (
        (child.questionType === "number" ||
          child.questionId === "number_of_trip_select") &&
        parseInt(currentValue) > 0 &&
        hasChildDependents
      ) {
        Array.from(
          { length: Math.min(parseInt(currentValue), 100) },
          (_, index) => index,
        ).forEach((loopIndex) => {
          collectVisibleQuestionKeys(
            child.questionId,
            {
              tripIndex: loopIndex,
              optionSuffix: childSuffix,
              repeatingParentId: child.questionId,
            },
            sourceAnswers,
            visibleKeys,
          );
        });
      } else {
        collectVisibleQuestionKeys(
          child.questionId,
          {
            tripIndex: context.tripIndex ?? null,
            optionSuffix: childSuffix,
            repeatingParentId: context.repeatingParentId || null,
          },
          sourceAnswers,
          visibleKeys,
        );
      }
    });

    return visibleKeys;
  };

  const clearHiddenDescendantAnswers = (
    parentId,
    nextAnswers,
    context = {},
  ) => {
    const descendantQuestionIds = collectQuestionDescendantIds(parentId);
    if (descendantQuestionIds.size === 0) return nextAnswers;

    const visibleKeys = collectVisibleQuestionKeys(
      parentId,
      context,
      nextAnswers,
      new Set(),
    );

    const updatedAnswers = { ...nextAnswers };

    Object.keys(updatedAnswers).forEach((answerKey) => {
      const belongsToDescendant = Array.from(descendantQuestionIds).some(
        (questionId) =>
          answerKey === questionId || answerKey.startsWith(`${questionId}_`),
      );

      if (!belongsToDescendant) return;

      // Only check and delete descendant keys that belong to this specific parent instance's suffix branch
      if (context.optionSuffix) {
        const escapedSuffix = context.optionSuffix.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&",
        );
        const suffixPattern = `_${escapedSuffix}(?:$|${SUFFIX_SEP})`;
        const regex = new RegExp(suffixPattern);
        if (!regex.test(answerKey)) {
          return;
        }
      }

      // Only check and delete descendant keys that belong to the current tripIndex
      if (
        context.tripIndex !== null &&
        context.tripIndex !== undefined &&
        context.repeatingParentId !== parentId
      ) {
        const tripPattern = `_trip_${context.tripIndex}(?:_|$)`;
        const regex = new RegExp(tripPattern);
        if (!regex.test(answerKey)) {
          return;
        }
      }

      const stillVisible = Array.from(visibleKeys).some(
        (visibleKey) =>
          answerKey === visibleKey ||
          answerKey.startsWith(`${visibleKey}_`) ||
          answerKey.startsWith(`${visibleKey}${SUFFIX_SEP}`),
      );

      if (!stillVisible) {
        delete updatedAnswers[answerKey];
      }
    });

    return updatedAnswers;
  };

  const isChildVisible = (
    child,
    parentId,
    tripIndex,
    optionSuffix,
    repeatingParentId,
  ) => {
    if (
      (child.questionId === "scope3_categories_capital_goods_table" ||
        child.questionId === "scope3_categories_non_capital_goods_table") &&
      parentId === "scope3_first"
    ) {
      return evalCondition(child, {
        tripIndex,
        optionSuffix,
        repeatingParentId,
      });
    }

    if (!child.displayCondition) return false;

    const parentConditions = child.displayCondition.filter(
      (c) => c.triggerQuestionId === parentId,
    );
    if (parentConditions.length === 0) return false;

    const logicalOp = (child.logicalOperator || "AND").toUpperCase();
    const isSatisfied = (c) => {
      if (repeatingParentId && c.triggerQuestionId === parentId) return true;
      return evalCondition(c, {
        tripIndex,
        optionSuffix,
        repeatingParentId,
      });
    };

    if (logicalOp === "OR") {
      return parentConditions.some(isSatisfied);
    }

    return parentConditions.some(isSatisfied);
  };

  const renderChildren = (
    parentId,
    parentQuestionNumber,
    depth,
    tripIndex,
    optionSuffix = null,
    repeatingParentId = null,
    isParentMandatory = false,
  ) => {
    const candidates =
      questionTree.childrenByParent.get(parentId) ||
      questionsList.filter((child) =>
        child.displayCondition?.some((c) => c.triggerQuestionId === parentId),
      );

    const visibleChildren = sortByOrderIndex(
      candidates.filter((child) =>
        isChildVisible(
          child,
          parentId,
          tripIndex,
          optionSuffix,
          repeatingParentId,
        ),
      ),
      questionTree.orderIndex,
      (q) => q.questionId,
    );

    let siblingIndex = 0;

    return visibleChildren.map((child) => {
      let childQuestionNumber = "";
      if (isNumberedType(child.questionType)) {
        siblingIndex += 1;
        childQuestionNumber = formatSerialNumber(
          parentQuestionNumber,
          siblingIndex,
        );
      }

      let childSuffix = optionSuffix;

      if (child.displayCondition) {
        const specificCond = child.displayCondition.find(
          (c) =>
            c.triggerQuestionId === parentId &&
            c.operator === "eq" &&
            typeof c.value === "string",
        );
        if (specificCond) {
          childSuffix = optionSuffix
            ? `${optionSuffix}${SUFFIX_SEP}${specificCond.value}`
            : specificCond.value;
        }
      }

      return renderQuestion(
        child,
        depth,
        tripIndex,
        childSuffix,
        repeatingParentId,
        childQuestionNumber,
        isParentMandatory,
      );
    });
  };

  // Replace the renderQuestionInstance function with this fixed version:

  const renderQuestionInstance = (
    question,
    depth,
    tripIndex,
    optionSuffix = null,
    repeatingParentId = null,
    questionNumber = "",
    isParentMandatory = false,
  ) => {
    const originalQid = question.questionId;
    const effectiveMandatory = !!(question.mandatory || isParentMandatory);

    // Find the label for the optionSuffix if it exists
    let optionLabel = optionSuffix;
    let isMultiselectDependent = false;

    if (optionSuffix) {
      // Use only the last part of the hierarchical suffix for the label
      const displaySuffix = optionSuffix.includes(SUFFIX_SEP)
        ? optionSuffix.substring(
            optionSuffix.lastIndexOf(SUFFIX_SEP) + SUFFIX_SEP.length,
          )
        : optionSuffix;
      optionLabel = displaySuffix;
      //console.log(optionLabel, "optionLabel--Rachna")
      // ONLY check for multiselect dependencies with "exists" operator
      if (question.displayCondition) {
        const multiselectExistsDep = question.displayCondition.find((cond) => {
          if (cond.operator !== "exists") return false;
          const triggerField = questionsList.find(
            (q) => q.questionId === cond.triggerQuestionId,
          );
          return triggerField?.questionType === "multiselect";
        });

        if (multiselectExistsDep) {
          isMultiselectDependent = true;
          const triggerId = multiselectExistsDep.triggerQuestionId;
          const triggerQuestion = questionsList.find(
            (q) => q.questionId === triggerId,
          );
          let foundOption = null;

          // A. Check Static Options first
          if (
            triggerQuestion?.options &&
            Array.isArray(triggerQuestion.options)
          ) {
            foundOption = triggerQuestion.options.find(
              (opt) => opt.value === displaySuffix,
            );
          }

          // B. Check Cached Options if static options didn't work
          if (!foundOption) {
            const cachedOptions = optionsCache[triggerId];
            if (cachedOptions && Array.isArray(cachedOptions)) {
              foundOption = cachedOptions.find(
                (opt) => opt.value === displaySuffix,
              );
            }
          }

          // C. If still not found, try to fetch from table definitions
          if (!foundOption && tableDefs[triggerId]) {
            const tableDef = tableDefs[triggerId];
            if (tableDef.fields) {
              const categoryField = tableDef.fields.find(
                (f) =>
                  f.fieldType === "multiselect" &&
                  (!f.displayCondition || f.displayCondition.length === 0),
              );
              if (categoryField?.options) {
                foundOption = categoryField.options.find(
                  (opt) => opt.value === displaySuffix,
                );
              }
            }
          }

          if (foundOption) {
            optionLabel = foundOption.label;
          }
        }
      }
    }

    // Construct the key: questionId [_trip_0] [_optionVal]
    let qid = originalQid;
    if (tripIndex !== null) qid += `_trip_${tripIndex}`;
    if (optionSuffix) qid += `_${optionSuffix}`;

    const currentValue = answers[qid];
    const hasConditionalChildren = questionsList.some((child) =>
      child.displayCondition?.some(
        (condition) => condition.triggerQuestionId === originalQid,
      ),
    );

    const handleQuestionValueChange = (val) => {
      if (!fillFrom) return;

      setAnswers((prev) => {
        const nextAnswers = {
          ...prev,
          [qid]: val,
        };

        if (!hasConditionalChildren) {
          return nextAnswers;
        }

        return clearHiddenDescendantAnswers(originalQid, nextAnswers, {
          tripIndex,
          optionSuffix,
          repeatingParentId,
        });
      });
    };

    const handleQuestionBlur = () => {
      if (
        !hasConditionalChildren ||
        (question.questionType !== "number" &&
          question.questionType !== "percentage")
      ) {
        return;
      }

      setAnswers((prev) =>
        clearHiddenDescendantAnswers(originalQid, prev, {
          tripIndex,
          optionSuffix,
          repeatingParentId,
        }),
      );
    };

    const displayNumber = formatSerialDisplay(questionNumber);

    return (
      <div
        key={qid}
        className={`bg-white rounded-lg shadow-sm border border-gray-200 p-5 ${depth > 0 ? " mt-3 border-l-4 border-l-teal-500" : "mb-4"}`}
      >
        <label className="block text-base font-semibold text-gray-800 mb-3">
          {question.questionTitle && question.questionTitle.length > 0 && (
            <div className="text-teal-700 font-semibold mb-2 border-b pb-1">
              {question.questionTitle[0]}
            </div>
          )}
          {question.guidance && question.guidance.length > 0 && (
            <div className="mb-3 p-3 bg-blue-50 rounded border-l-4 border-blue-400">
              <p className="text-xs font-semibold text-blue-800 mb-2">
                💡 Guidance:
              </p>
              <ul className="text-xs text-gray-700 space-y-1 list-disc list-inside">
                {question.guidance.map((item, idx) => (
                  <li key={idx} className="leading-relaxed">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <span className="text-teal-700 mr-2">{displayNumber}</span>
          {question.questionText}
          {optionSuffix && isMultiselectDependent && (
            <span className="ml-2 px-3 py-1 bg-teal-100 text-teal-700 rounded-full text-sm font-medium">
              {optionLabel}
            </span>
          )}
          <RequiredMark show={effectiveMandatory} />
        </label>

        {question.questionType === "table" ? (
          <FormQuestionTable
            renderTable={() => (
              <TableManager
                question={question}
                tableId={qid}
                answers={answers}
                setAnswers={setAnswers}
                evalCondition={evalCondition}
                tripIndex={tripIndex}
                onLoadDefinition={(def) =>
                  setTableDefs((prev) => {
                    if (
                      prev[question.questionId] &&
                      JSON.stringify(prev[question.questionId]) ===
                        JSON.stringify(def)
                    )
                      return prev;
                    return { ...prev, [question.questionId]: def };
                  })
                }
                parentMandatory={effectiveMandatory}
                parentQuestionNumber={questionNumber}
                readOnly={!fillFrom}
              />
            )}
          />
        ) : (
          <FormQuestionInput
            field={question}
            value={currentValue}
            disabled={!fillFrom}
            onChange={handleQuestionValueChange}
            onBlur={handleQuestionBlur}
            onOptionsLoaded={(qid, opts) => {
              setOptionsCache((prev) => {
                if (JSON.stringify(prev[qid]) === JSON.stringify(opts))
                  return prev;
                return { ...prev, [qid]: opts };
              });
            }}
          />
        )}

        {/* --- GENERIC NUMBER REPETITION LOOP --- */}
        {(question.questionType === "number" ||
          originalQid === "number_of_trip_select") &&
        parseInt(currentValue) > 0 &&
        questionsList.some((child) =>
          child.displayCondition?.some(
            (c) => c.triggerQuestionId === originalQid,
          ),
        ) ? (
          <div className="mt-6 space-y-6">
            {Array.from(
              { length: Math.min(parseInt(currentValue), 100) },
              (_, i) => (
                <div
                  key={`${qid}_loop_${i}`}
                  className="p-4 border-2 border-teal-100 rounded-xl bg-teal-50/10"
                >
                  <div className="text-teal-600 font-bold mb-4 uppercase text-sm tracking-wider">
                    {originalQid.includes("trip") ||
                    originalQid.includes("journey")
                      ? "Trip"
                      : "Entry"}{" "}
                    {i + 1} {optionSuffix && `(${optionLabel})`}
                  </div>
                  {renderChildren(
                    originalQid,
                    formatSerialNumber(questionNumber, i + 1),
                    depth + 1,
                    i,
                    optionSuffix,
                    originalQid,
                    effectiveMandatory,
                  )}
                </div>
              ),
            )}
          </div>
        ) : (
          renderChildren(
            originalQid,
            questionNumber,
            depth + 1,
            tripIndex,
            optionSuffix,
            repeatingParentId,
            effectiveMandatory,
          )
        )}
      </div>
    );
  };

  const renderQuestion = (
    question,
    depth = 0,
    tripIndex = null,
    optionSuffix = null,
    repeatingParentId = null,
    questionNumber = "",
    isParentMandatory = false,
    rootCounter = null,
  ) => {
    const isVisible = evalCondition(question, {
      tripIndex,
      optionSuffix,
      repeatingParentId,
    });
    if (!isVisible) return null;

    let resolvedQuestionNumber = questionNumber;
    if (depth === 0 && rootCounter) {
      if (isNumberedType(question.questionType)) {
        rootCounter.current += 1;
        resolvedQuestionNumber = String(rootCounter.current);
      } else {
        resolvedQuestionNumber = "";
      }
    }

    const multiselectTriggerId = getMultiselectDependency(
      question,
      answers,
      tripIndex,
      optionSuffix,
    );

    if (multiselectTriggerId) {
      const getVal = () => {
        let items;
        // Similar to getMultiselectDependency fallback logic (re-implemented for safety here or could expose logic)
        if (answers[multiselectTriggerId])
          items = answers[multiselectTriggerId];
        if (!items) {
          let s = optionSuffix;
          while (!items) {
            if (tripIndex !== null && s)
              items = answers[`${multiselectTriggerId}_trip_${tripIndex}_${s}`];
            if (!items && s) items = answers[`${multiselectTriggerId}_${s}`];
            if (!items && tripIndex !== null)
              items = answers[`${multiselectTriggerId}_trip_${tripIndex}`];
            if (!items) items = answers[multiselectTriggerId];

            if (items || !s || !s.includes(SUFFIX_SEP)) break;
            s = s.substring(0, s.lastIndexOf(SUFFIX_SEP));
          }
        }
        return items || [];
      };

      const actualSelectedItems = (getVal() || []).filter((v) => v !== "");

      if (actualSelectedItems.length > 0) {
        return (
          <div key={`ms_${question.questionId}`} className="space-y-4">
            {actualSelectedItems.map((itemValue) =>
              renderQuestionInstance(
                question,
                depth,
                tripIndex,
                optionSuffix
                  ? `${optionSuffix}${SUFFIX_SEP}${itemValue}`
                  : itemValue,
                repeatingParentId,
                resolvedQuestionNumber,
                isParentMandatory,
              ),
            )}
          </div>
        );
      }
    }

    return renderQuestionInstance(
      question,
      depth,
      tripIndex,
      optionSuffix,
      repeatingParentId,
      resolvedQuestionNumber,
      isParentMandatory,
    );
  };

  // ============================================================================
  // PAYLOAD BUILDERS FOR DIFFERENT SUBSECTIONS
  // ============================================================================

  /**
   * Build payload for STANDARD TABLES (Capital Goods, Purchased Goods, Outsourced Vehicles, Waste Generated)
   * Handles: item_type grouping, percentage suffixes, multiselect dependencies
   */

  const buildStandardTablePayload = (
    qid,
    tableData,
    tableDef,
    configMonth = null,
  ) => {
    if (!tableData || typeof tableData !== "object") return null;

    const allRows = [];
    const tableFields = tableDef?.fields || [];

    // Find the root category/item_type field (select or multiselect without displayCondition)
    let categoryField = tableFields.find(
      (f) =>
        ["multiselect", "multi-select", "select"].includes(f.fieldType) &&
        (!f.displayCondition || f.displayCondition.length === 0) &&
        tableFields.some((other) =>
          other.displayCondition?.some(
            (cond) =>
              (cond.triggerQuestionId === f.fieldId ||
                cond.triggerFieldId === f.fieldId) &&
              cond.operator === "exists",
          ),
        ),
    );
    let rootMultiselectFields = tableFields.filter(
      (f) =>
        ["multiselect", "multi-select"].includes(f.fieldType) &&
        (!f.displayCondition || f.displayCondition.length === 0) &&
        tableFields.some((other) =>
          other.displayCondition?.some(
            (cond) =>
              (cond.triggerQuestionId === f.fieldId ||
                cond.triggerFieldId === f.fieldId) &&
              cond.operator === "exists",
          ),
        ),
    );

    // 2. Fallback: If no "pure" root field found, accept the first available select/multiselect
    // even if it has display conditions. This fixes issues where categorized tables depend on
    // external triggers but still have a defining category field.
    if (!categoryField) {
      categoryField = tableFields.find((f) =>
        ["multiselect", "multi-select", "select"].includes(f.fieldType),
      );
    }
    if (rootMultiselectFields.length === 0) {
      const firstMS = tableFields.find((f) =>
        ["multiselect", "multi-select"].includes(f.fieldType),
      );
      if (firstMS) rootMultiselectFields = [firstMS];
    }
    const isMultiRootMultiselectTable = rootMultiselectFields.length > 1;
    const itemTypeFieldId =
      typeof categoryField?.fieldId === "string" && categoryField.fieldId.trim()
        ? categoryField.fieldId.trim()
        : "item_type";
    const resolveActiveItemTypeFieldId = (rowValues = {}) => {
      const activeRootField = rootMultiselectFields.find((field) => {
        const fieldId = field?.fieldId;
        if (!fieldId) return false;
        if (rowValues[fieldId] !== undefined) return true;

        return Object.keys(rowValues).some(
          (key) =>
            key === fieldId ||
            key.startsWith(`${fieldId}_`) ||
            key.startsWith(`employee_detail_${fieldId}`) ||
            key.startsWith(`employee_detail_${fieldId}_`),
        );
      });

      if (
        typeof activeRootField?.fieldId === "string" &&
        activeRootField.fieldId.trim()
      ) {
        return activeRootField.fieldId.trim();
      }

      if (
        typeof categoryField?.fieldId === "string" &&
        categoryField.fieldId.trim()
      ) {
        return categoryField.fieldId.trim();
      }

      return itemTypeFieldId;
    };

    const getFieldById = (fieldId) =>
      tableFields.find((field) => field.fieldId === fieldId);

    const isRepeaterTriggerField = (fieldId) =>
      tableFields.some((other) =>
        other.displayCondition?.some(
          (condition) =>
            (condition.triggerQuestionId === fieldId ||
              condition.triggerFieldId === fieldId) &&
            condition.operator === "exists",
        ),
      );

    const findRepeaterParentFieldId = (fieldId, visited = new Set()) => {
      if (!fieldId || visited.has(fieldId)) return null;
      visited.add(fieldId);

      const field = getFieldById(fieldId);
      if (!field?.displayCondition?.length) return null;

      for (const condition of field.displayCondition) {
        const triggerFieldId =
          condition.triggerQuestionId || condition.triggerFieldId;
        if (!triggerFieldId) continue;

        const triggerField = getFieldById(triggerFieldId);
        if (
          triggerField?.fieldType === "number" &&
          isRepeaterTriggerField(triggerFieldId)
        ) {
          return triggerFieldId;
        }

        const ancestorRepeater = findRepeaterParentFieldId(
          triggerFieldId,
          visited,
        );
        if (ancestorRepeater) return ancestorRepeater;
      }

      return null;
    };

    const findRootMultiselectFieldId = (fieldId, visited = new Set()) => {
      if (!fieldId || visited.has(fieldId)) return null;
      visited.add(fieldId);

      const field = getFieldById(fieldId);
      if (!field?.displayCondition?.length) return null;

      for (const condition of field.displayCondition) {
        const triggerFieldId =
          condition.triggerQuestionId || condition.triggerFieldId;
        if (!triggerFieldId) continue;

        const triggerField = getFieldById(triggerFieldId);
        if (
          triggerField?.fieldType === "multiselect" &&
          (!triggerField.displayCondition ||
            triggerField.displayCondition.length === 0)
        ) {
          return triggerFieldId;
        }

        const ancestorRoot = findRootMultiselectFieldId(
          triggerFieldId,
          visited,
        );
        if (ancestorRoot) return ancestorRoot;
      }

      return null;
    };

    const addUniqueArrayValue = (target, fieldId, nextValue) => {
      if (!nextValue && nextValue !== 0) return;
      const current = Array.isArray(target[fieldId]) ? target[fieldId] : [];
      if (!current.includes(nextValue)) {
        target[fieldId] = [...current, nextValue];
      }
    };

    const addKeyValueEntry = (target, fieldId, entryKey, entryValue) => {
      if (!entryKey && entryKey !== 0) return;
      const current = Array.isArray(target[fieldId]) ? target[fieldId] : [];
      const nextEntries = [...current];
      const existingIndex = nextEntries.findIndex(
        (item) => item?.key === entryKey,
      );
      const normalizedEntry = { key: entryKey, value: entryValue };

      if (existingIndex >= 0) {
        nextEntries[existingIndex] = normalizedEntry;
      } else {
        nextEntries.push(normalizedEntry);
      }

      target[fieldId] = nextEntries;
    };

    const mergeTableRowValues = (existingValues = {}, incomingValues = {}) => {
      const merged = { ...existingValues };

      Object.entries(incomingValues).forEach(([fieldId, incomingValue]) => {
        const currentValue = merged[fieldId];

        if (Array.isArray(currentValue) && Array.isArray(incomingValue)) {
          const isKeyValueArray = (value) =>
            value.every(
              (item) =>
                item &&
                typeof item === "object" &&
                !Array.isArray(item) &&
                Object.prototype.hasOwnProperty.call(item, "key") &&
                Object.prototype.hasOwnProperty.call(item, "value"),
            );

          if (isKeyValueArray(currentValue) && isKeyValueArray(incomingValue)) {
            const keyed = new Map(currentValue.map((item) => [item.key, item]));
            incomingValue.forEach((item) => keyed.set(item.key, item));
            merged[fieldId] = Array.from(keyed.values());
          } else {
            merged[fieldId] = Array.from(
              new Set([...currentValue, ...incomingValue]),
            );
          }
          return;
        }

        if (
          currentValue &&
          typeof currentValue === "object" &&
          !Array.isArray(currentValue) &&
          incomingValue &&
          typeof incomingValue === "object" &&
          !Array.isArray(incomingValue)
        ) {
          merged[fieldId] = { ...currentValue, ...incomingValue };
          return;
        }

        if (
          currentValue === undefined ||
          currentValue === null ||
          currentValue === ""
        ) {
          merged[fieldId] = incomingValue;
        }
      });

      return merged;
    };

    // Prepare a helper to process a single row
    const processRow = (row, itemType) => {
      if (!row || !row.values) return null;
      const activeItemTypeFieldId = resolveActiveItemTypeFieldId(row.values);
      const activeItemTypeField = getFieldById(activeItemTypeFieldId);
      const directRootValue = row.values[activeItemTypeFieldId];
      const isPlaceholderRootValue =
        directRootValue === "default" ||
        (Array.isArray(directRootValue) &&
          directRootValue.length === 1 &&
          directRootValue[0] === "default");
      const resolvedItemType =
        itemType && itemType !== "default" ? itemType : null;
      const processedValues = isMultiRootMultiselectTable
        ? {}
        : (() => {
            if (
              directRootValue !== undefined &&
              directRootValue !== null &&
              directRootValue !== "" &&
              !isPlaceholderRootValue
            ) {
              return {
                [activeItemTypeFieldId]: directRootValue,
              };
            }

            if (resolvedItemType) {
              return {
                [activeItemTypeFieldId]:
                  activeItemTypeField?.fieldType === "select"
                    ? resolvedItemType
                    : [resolvedItemType],
              };
            }

            return {};
          })();
      const usedKeys = new Set();

      tableFields.forEach((field) => {
        if (field.fieldId === activeItemTypeFieldId && itemType !== "default")
          return;

        // 1. REPEATER CHECK (e.g., number_of_vehicles triggers loop)
        const isRepeaterTrigger =
          field.fieldType === "number" &&
          tableFields.some((other) =>
            other.displayCondition?.some(
              (c) =>
                (c.triggerQuestionId === field.fieldId ||
                  c.triggerFieldId === field.fieldId) &&
                c.operator === "exists",
            ),
          );

        if (isRepeaterTrigger) {
          const count = parseInt(row.values[field.fieldId]) || 0;
          if (count > 0) {
            const collectDescendants = (parentIds, collected = new Set()) => {
              const children = tableFields.filter(
                (other) =>
                  !collected.has(other.fieldId) &&
                  other.displayCondition?.some((c) =>
                    parentIds.includes(c.triggerQuestionId || c.triggerFieldId),
                  ),
              );

              if (children.length === 0) return Array.from(collected);

              const childIds = children.map((c) => c.fieldId);
              children.forEach((c) => collected.add(c.fieldId));
              return collectDescendants(childIds, collected);
            };

            const descendantFieldIds = collectDescendants([field.fieldId]);
            const descendantFields = tableFields.filter((f) =>
              descendantFieldIds.includes(f.fieldId),
            );

            const detailsArray = [];
            for (let i = 0; i < count; i++) {
              const detailObj = {};
              descendantFields.forEach((cf) => {
                const loopPrefix = `${cf.fieldId}_loop_${i}`;
                // Mark the base fieldId as used
                usedKeys.add(cf.fieldId);

                // Scan row values to find all keys matching this loop entry (direct or suffixed)
                Object.keys(row.values).forEach((key) => {
                  if (key === loopPrefix || key.startsWith(`${loopPrefix}_`)) {
                    let val = row.values[key];
                    if (val === undefined || val === null || val === "") return;

                    // Numeric conversion for children
                    const isNum =
                      cf.fieldType === "number" ||
                      cf.fieldType === "percentage" ||
                      (!isNaN(Number(val)) &&
                        (cf.fieldId.includes("distance") ||
                          cf.fieldId.includes("fuel_consumption") ||
                          cf.fieldId.includes("quantity")));

                    // Store in detail using a key relative to fieldId
                    const storageKey =
                      key === loopPrefix
                        ? cf.fieldId
                        : cf.fieldId + key.substring(loopPrefix.length);

                    detailObj[storageKey] = isNum ? Number(val) : val;
                    usedKeys.add(key);
                  }
                });
              });
              if (Object.keys(detailObj).length > 0) {
                detailsArray.push(detailObj);
              }
            }
            if (detailsArray.length > 0) {
              processedValues[`${field.fieldId}_details`] = detailsArray;
            }
          }
        }

        // Skip if already processed as part of a repeater
        if (usedKeys.has(field.fieldId)) return;

        // A. Check for Direct Value
        const directVal = row.values[field.fieldId];
        if (directVal !== undefined && directVal !== null && directVal !== "") {
          const rootMultiselectFieldId = isMultiRootMultiselectTable
            ? findRootMultiselectFieldId(field.fieldId)
            : null;

          if (
            isMultiRootMultiselectTable &&
            rootMultiselectFieldId &&
            itemType &&
            itemType !== "default"
          ) {
            addUniqueArrayValue(
              processedValues,
              rootMultiselectFieldId,
              itemType,
            );
          }

          // Check if it's numeric by type OR by keywords in fieldId/label
          const isNumberType =
            field.fieldType === "number" || field.fieldType === "percentage";
          const looksNumeric =
            !Array.isArray(directVal) &&
            !isNaN(Number(directVal)) &&
            (field.fieldId.includes("quantity") ||
              field.fieldId.includes("percentage") ||
              field.fieldId.includes("amount") ||
              field.fieldId.includes("consumption") ||
              field.fieldId.includes("size") ||
              field.fieldId.includes("number") ||
              (field.fieldLabel || "").toLowerCase().includes("percentage") ||
              (field.fieldLabel || "").toLowerCase().includes("quantity") ||
              (field.fieldLabel || "").toLowerCase().includes("consumption") ||
              (field.fieldLabel || "").toLowerCase().includes("size"));

          if (
            isMultiRootMultiselectTable &&
            rootMultiselectFieldId &&
            itemType &&
            itemType !== "default"
          ) {
            const normalizedDirectVal =
              isNumberType || looksNumeric ? Number(directVal) : directVal;
            addKeyValueEntry(
              processedValues,
              field.fieldId,
              itemType,
              normalizedDirectVal,
            );
          } else if (isNumberType || looksNumeric) {
            processedValues[field.fieldId] = Number(directVal);
          } else {
            processedValues[field.fieldId] = directVal;
          }
          usedKeys.add(field.fieldId);
          return;
        }

        // B. Check for Suffixed Values
        const collected = [];
        Object.keys(row.values).forEach((key) => {
          if (usedKeys.has(key)) return;
          if (key.startsWith(`${field.fieldId}_`)) {
            const suffix = stripLoopPrefix(
              key.replace(`${field.fieldId}_`, ""),
            );
            let val = row.values[key];
            if (val !== undefined && val !== null && val !== "") {
              const isNumberType =
                field.fieldType === "number" ||
                field.fieldType === "percentage";
              const looksNumeric =
                !Array.isArray(val) &&
                !isNaN(Number(val)) &&
                (key.includes("quantity") ||
                  key.includes("percentage") ||
                  key.includes("amount") ||
                  key.includes("consumption") ||
                  key.includes("size") ||
                  key.includes("number") ||
                  (field.fieldLabel || "")
                    .toLowerCase()
                    .includes("percentage") ||
                  (field.fieldLabel || "")
                    .toLowerCase()
                    .includes("consumption") ||
                  (field.fieldLabel || "").toLowerCase().includes("size"));

              if (isNumberType || looksNumeric) {
                val = Number(val);
              }
              collected.push({ key: suffix, value: val });

              if (
                isMultiRootMultiselectTable &&
                itemType &&
                itemType !== "default" &&
                suffix === itemType
              ) {
                const rootMultiselectFieldId = findRootMultiselectFieldId(
                  field.fieldId,
                );
                if (rootMultiselectFieldId) {
                  addUniqueArrayValue(
                    processedValues,
                    rootMultiselectFieldId,
                    itemType,
                  );
                }
              }
              usedKeys.add(key);
            }
          }
        });

        if (collected.length > 0) {
          processedValues[field.fieldId] = collected;
        }
      });

      const repeaterDetailGroups = {};
      Object.keys(row.values).forEach((key) => {
        if (usedKeys.has(key)) return;

        const loopMatch = key.match(/^(.*)_loop_(\d+)$/);
        if (!loopMatch) return;

        const [, fieldId, loopIndexRaw] = loopMatch;
        const repeaterParentFieldId = findRepeaterParentFieldId(fieldId);
        if (!repeaterParentFieldId) return;

        const val = row.values[key];
        if (val === undefined || val === null || val === "") return;

        const childField = getFieldById(fieldId);
        const loopIndex = Number(loopIndexRaw);
        const detailKey = `${repeaterParentFieldId}_details`;

        if (!repeaterDetailGroups[detailKey]) {
          repeaterDetailGroups[detailKey] = [];
        }

        if (!repeaterDetailGroups[detailKey][loopIndex]) {
          repeaterDetailGroups[detailKey][loopIndex] = {};
        }

        const isNumberType =
          childField?.fieldType === "number" ||
          childField?.fieldType === "percentage";
        const looksNumeric =
          !Array.isArray(val) &&
          !isNaN(Number(val)) &&
          (fieldId.includes("quantity") ||
            fieldId.includes("percentage") ||
            fieldId.includes("amount") ||
            fieldId.includes("value") ||
            fieldId.includes("number") ||
            fieldId.includes("consumption") ||
            fieldId.includes("size"));

        repeaterDetailGroups[detailKey][loopIndex][fieldId] =
          isNumberType || looksNumeric ? Number(val) : val;
        usedKeys.add(key);
      });

      Object.entries(repeaterDetailGroups).forEach(
        ([detailKey, detailRows]) => {
          const normalizedDetails = detailRows.filter(
            (detailRow) => detailRow && Object.keys(detailRow).length > 0,
          );

          if (normalizedDetails.length === 0) return;

          const existingDetails = Array.isArray(processedValues[detailKey])
            ? processedValues[detailKey]
            : [];

          processedValues[detailKey] = [
            ...existingDetails,
            ...normalizedDetails,
          ];
        },
      );

      // Fallback for fields not in tableFields and not already used
      Object.keys(row.values).forEach((key) => {
        if (usedKeys.has(key)) return;
        if (processedValues[key] === undefined) {
          const isSuffixedForKnownField = tableFields.some((f) =>
            key.startsWith(`${f.fieldId}_`),
          );
          if (!isSuffixedForKnownField) {
            const val = row.values[key];
            if (val !== undefined && val !== null && val !== "") {
              const looksNumeric =
                !Array.isArray(val) &&
                !isNaN(Number(val)) &&
                (key.includes("quantity") ||
                  key.includes("percentage") ||
                  key.includes("amount") ||
                  key.includes("value") ||
                  key.includes("number") ||
                  key.includes("consumption") ||
                  key.includes("size"));
              processedValues[key] = looksNumeric ? Number(val) : val;
            }
          }
        }
      });

      // Add configMonth suffix to numeric keys if configMonth is present
      if (configMonth) {
        const renamedValues = {};
        Object.keys(processedValues).forEach((key) => {
          const field = getFieldById(key);
          const val = processedValues[key];
          const isNumberType =
            field?.fieldType === "number" ||
            field?.fieldType === "percentage" ||
            (!Array.isArray(val) &&
              !isNaN(Number(val)) &&
              typeof val === "number");

          if (isNumberType && !key.endsWith(`_${configMonth}`)) {
            renamedValues[`${key}_${configMonth}`] = val;
          } else {
            renamedValues[key] = val;
          }
        });
        return { rowId: row.rowId, values: renamedValues };
      }

      return { rowId: row.rowId, values: processedValues };
    };

    // Handle both Array (old/simple) and Object (categorized) formats
    if (Array.isArray(tableData)) {
      tableData.forEach((row) => {
        const payload = processRow(row, null);
        if (payload) allRows.push(payload);
      });
    } else {
      Object.keys(tableData).forEach((itemType) => {
        const itemRows = tableData[itemType];
        if (Array.isArray(itemRows)) {
          itemRows.forEach((row) => {
            const payload = processRow(row, itemType);
            if (payload) allRows.push(payload);
          });
        }
      });
    }

    const normalizedRows = isMultiRootMultiselectTable
      ? Array.from(
          allRows
            .reduce((rowMap, row) => {
              const existingRow = rowMap.get(row.rowId);
              if (!existingRow) {
                rowMap.set(row.rowId, row);
                return rowMap;
              }

              rowMap.set(row.rowId, {
                ...existingRow,
                values: mergeTableRowValues(existingRow.values, row.values),
              });

              return rowMap;
            }, new Map())
            .values(),
        )
      : allRows;

    if (normalizedRows.length === 0) return null;
    return {
      questionId: stripLoopTokenFromId(qid),
      questionType: "table",
      tableRows: normalizedRows,
    };
  };

  /**
   * Build payload for PURCHASED SERVICES (number questions with multiselect dependency)
   * Expected output: { questionId, questionType: "number", value: [{key, value}, ...] }
   */
  const buildMultiselectDependentNumberPayload = (
    qid,
    questionType,
    multiselectTriggerId,
    sourceAnswers = answers,
  ) => {
    const selectedItemsByContext = new Map();
    const rootSelectedItems = sourceAnswers[multiselectTriggerId];

    if (Array.isArray(rootSelectedItems) && rootSelectedItems.length > 0) {
      selectedItemsByContext.set("", rootSelectedItems);
    }

    Object.keys(sourceAnswers).forEach((answerKey) => {
      if (
        answerKey === multiselectTriggerId ||
        !answerKey.startsWith(`${multiselectTriggerId}_`) ||
        answerKey.includes("_trip_")
      ) {
        return;
      }

      const selectedItems = sourceAnswers[answerKey];
      if (!Array.isArray(selectedItems) || selectedItems.length === 0) return;

      const contextSuffix = answerKey.substring(
        multiselectTriggerId.length + 1,
      );
      selectedItemsByContext.set(contextSuffix, selectedItems);
    });

    if (selectedItemsByContext.size === 0) return null;

    const collected = [];
    const resolveAnswerValue = (baseKey) => {
      const matchingKey = Object.keys(sourceAnswers).find((candidateKey) => {
        if (candidateKey === baseKey) return true;
        if (candidateKey.startsWith(`${baseKey}${SUFFIX_SEP}`)) return true;
        if (candidateKey.startsWith(`${baseKey}_loop_`)) return true;
        return false;
      });

      if (!matchingKey) return undefined;
      return sourceAnswers[matchingKey];
    };

    const upsertCollectedValue = (itemKey, rawValue) => {
      if (rawValue === undefined || rawValue === null || rawValue === "")
        return;

      const numericVal = Number(rawValue);
      const normalizedValue =
        questionType === "number" || questionType === "percentage"
          ? isNaN(numericVal)
            ? 0
            : numericVal
          : rawValue;

      const existingIndex = collected.findIndex((item) => item.key === itemKey);
      if (existingIndex >= 0) {
        collected[existingIndex] = { key: itemKey, value: normalizedValue };
      } else {
        collected.push({ key: itemKey, value: normalizedValue });
      }
    };

    selectedItemsByContext.forEach((selectedItems, contextSuffix) => {
      selectedItems.forEach((itemVal) => {
        if (!itemVal) return;

        const candidateKeys = [];
        if (contextSuffix) {
          candidateKeys.push(`${qid}_${contextSuffix}${SUFFIX_SEP}${itemVal}`);
        }
        candidateKeys.push(`${qid}_${itemVal}`);

        const matchedKey = candidateKeys.find((candidateKey) => {
          const matchedValue = resolveAnswerValue(candidateKey);
          return (
            matchedValue !== undefined &&
            matchedValue !== null &&
            matchedValue !== ""
          );
        });

        if (!matchedKey) return;
        upsertCollectedValue(itemVal, resolveAnswerValue(matchedKey));
      });
    });

    return collected.length > 0
      ? {
          questionId: stripLoopTokenFromId(qid),
          questionType: questionType,
          value: collected,
        }
      : null;
  };

  const stripLoopPrefix = (value) => {
    if (typeof value !== "string") return value;
    return value.replace(/^loop_\d+_/, "");
  };

  const stripLoopTokenFromId = (value) => {
    if (typeof value !== "string") return value;
    return value.replace(/_loop_\d+/g, "");
  };

  const stripMonthSuffixFromId = (value, month) => {
    if (typeof value !== "string" || !month) return value;
    const monthSuffix = `_${month}`;
    return value.endsWith(monthSuffix)
      ? value.slice(0, -monthSuffix.length)
      : value;
  };

  /**
   * Build payload for BUSINESS TRAVEL (complex nested structure with trips)
   * Expected output: { questionId, questionType: "table", value: [...nested structure...] }
   */
  /**
   * Build specialized payload for BUSINESS TRAVEL subsection
   * Matches the nested structure required by the backend
   */
  /**
   * Build specialized payload for BRANCHING TRIP structures
   * Used by Business Travel and Employee Details
   */
  const buildGenericTripBranchingPayload = (sourceAnswers, config) => {
    const formattedAnswers = [];
    const {
      prefix = "",
      division = "no_division",
      rootQids = [],
      branches = [],
      tripChildQids = [],
      returnTables = [],
      returnBranchQids = [],
    } = config;

    // 1. Root Questions
    rootQids.forEach((baseQid) => {
      const qid = prefix + baseQid;
      const monthSuffix = config.month ? `_${config.month}` : "";
      const monthQid = monthSuffix ? qid + monthSuffix : qid;

      // Try month-suffixed key first (e.g. "type_of_business_jan"), fall back to bare key
      const val =
        sourceAnswers[monthQid] !== undefined
          ? sourceAnswers[monthQid]
          : sourceAnswers[qid];

      if (
        val !== undefined &&
        val !== null &&
        (Array.isArray(val) ? val.length > 0 : val !== "")
      ) {
        // Find question definition — try suffixed ID first, then bare ID
        const q =
          questionsList.find((q) => q.questionId === monthQid) ||
          questionsList.find((q) => q.questionId === qid);
        if (q) {
          const numericVal = Number(val);
          formattedAnswers.push({
            questionId: stripMonthSuffixFromId(
              stripLoopTokenFromId(monthQid),
              config.month,
            ),
            month: config.month || undefined,
            division: division,
            questionType: q.questionType,
            value:
              q.questionType === "number"
                ? isNaN(numericVal)
                  ? 0
                  : numericVal
                : val,
          });
        }
      }
    });

    // 2. Branching Trip Loops
    branches.forEach(({ countQid: baseCountQid, branchId }) => {
      const monthSuffix = config.month ? `_${config.month}` : "";
      const hierarchicalSuffix = config.month
        ? `${config.month}${SUFFIX_SEP}${branchId}`
        : branchId;
      const countQid = prefix + baseCountQid + monthSuffix;

      let countKey = `${prefix}${baseCountQid}_${hierarchicalSuffix}`;
      let count = Number(sourceAnswers[countKey]);

      if (!count || count <= 0) {
        const flatCountKey = `${countQid}_${branchId}`;
        countKey = flatCountKey;
        count = Number(sourceAnswers[flatCountKey]);
      }

      if (!count || count <= 0) return;

      const detailsKey = `${countQid}_details`;
      const detailsArray = [];

      for (let i = 0; i < count; i++) {
        const tripKey = `${prefix}${baseCountQid}_${i + 1}`;
        const tripAnswers = [];

        tripChildQids.forEach((baseChildQid) => {
          const qid =
            (baseChildQid.startsWith("return_") ? "" : prefix) + baseChildQid;

          const hierarchicalBaseKey = `${qid}_trip_${i}_${hierarchicalSuffix}`;
          const flatBaseKey = `${qid}_trip_${i}_${config.month ? config.month + "_" + branchId : branchId}`;

          const relevantKeys = Object.keys(sourceAnswers).filter(
            (k) =>
              k === hierarchicalBaseKey ||
              k.startsWith(`${hierarchicalBaseKey}${SUFFIX_SEP}`) ||
              k === flatBaseKey ||
              k.startsWith(`${flatBaseKey}${SUFFIX_SEP}`) ||
              // And support the older structure where branchId was used directly on top of month suffix
              k === `${qid}_trip_${i}_${branchId}` ||
              k.startsWith(`${qid}_trip_${i}_${branchId}${SUFFIX_SEP}`),
          );

          if (relevantKeys.length === 0) return;

          relevantKeys.forEach((fullKey) => {
            const val = sourceAnswers[fullKey];
            if (
              val === undefined ||
              val === null ||
              (Array.isArray(val) ? val.length === 0 : val === "")
            )
              return;

            const q = questionsList.find((q) => q.questionId === qid);
            if (!q) return;

            if (q.questionType === "table") {
              const tableDef = tableDefs[qid];
              const payload = buildStandardTablePayload(
                qid,
                val,
                tableDef,
                config.month,
              );
              if (payload) {
                const existingTable = tripAnswers.find(
                  (ta) => ta.questionId === qid,
                );
                if (existingTable) {
                  existingTable.tableRows = [
                    ...existingTable.tableRows,
                    ...payload.tableRows,
                  ];
                } else {
                  tripAnswers.push({
                    questionId: stripLoopTokenFromId(qid),
                    month: config.month || undefined,
                    division: division,
                    questionType: "table",
                    tableRows: payload.tableRows,
                  });
                }
              }
            } else {
              const existingIdx = tripAnswers.findIndex(
                (ta) => ta.questionId === qid,
              );
              if (existingIdx >= 0) {
                if (
                  Array.isArray(val) &&
                  Array.isArray(tripAnswers[existingIdx].value)
                ) {
                  tripAnswers[existingIdx].value = [
                    ...new Set([...tripAnswers[existingIdx].value, ...val]),
                  ];
                }
              } else {
                const numericVal = Number(val);
                tripAnswers.push({
                  questionId: stripMonthSuffixFromId(
                    stripLoopTokenFromId(qid),
                    config.month,
                  ),
                  month: config.month || undefined,
                  division: division,
                  questionType: q.questionType,
                  value:
                    q.questionType === "number"
                      ? isNaN(numericVal)
                        ? 0
                        : numericVal
                      : val,
                });
              }
            }
          });
        });

        if (tripAnswers.length > 0) {
          detailsArray.push({ [tripKey]: tripAnswers });
        }
      }

      formattedAnswers.push({
        questionId: stripMonthSuffixFromId(
          stripLoopTokenFromId(countQid),
          config.month,
        ),
        month: config.month || undefined,
        division: division,
        questionType: "number",
        value: count,
        [`${stripLoopTokenFromId(prefix + baseCountQid)}_details`]:
          detailsArray,
      });
    });

    return formattedAnswers;
  };

  const buildBusinessTravelSubsectionPayload = (sourceAnswers = answers) => {
    const selectedMonths = sourceAnswers["month_trip"] || [];
    const formattedAnswers = [];

    // 1. Global questions (total_number_of_trip, month_trip)
    const rootQids = ["total_number_of_trip", "month_trip"];
    rootQids.forEach((qid) => {
      const val = sourceAnswers[qid];
      if (
        val !== undefined &&
        val !== null &&
        (Array.isArray(val) ? val.length > 0 : val !== "")
      ) {
        const q = questionsList.find((q) => q.questionId === qid);
        if (q) {
          formattedAnswers.push({
            questionId: qid,
            division: "business_travel_no_divison",
            questionType: q.questionType,
            value: q.questionType === "number" ? Number(val) : val,
          });
        }
      }
    });

    // 2. Monthly branching questions
    selectedMonths.forEach((month) => {
      const monthPayload = buildGenericTripBranchingPayload(sourceAnswers, {
        prefix: "",
        month: month,
        division: "business_travel_no_divison",
        rootQids: [
          `type_of_business`,
          `business_travel_returnmode_same`,
          `return_no_selected`,
          `return_destination`,
          `no_selected`,
        ],
        branches: [
          {
            countQid: "number_of_trip_individual",
            branchId: "individual_business_travel",
          },
          {
            countQid: "number_of_trip_group",
            branchId: "group_business_travel",
          },
        ],
        tripChildQids: [
          "type_of_trip",
          "mode_transportation",
          "air_travel_type",
          "rail_travel_type",
          "maritime_travel_type",
          "road_travel_type",
          "business_travel_returnmode_same",
          "return_no_selected",
          "return_destination",
          "no_selected",
          "return_air_travel_type",
          "return_rail_travel_type",
          "return_maritime_travel_type",
          "return_road_travel_type",
        ],
      });
      formattedAnswers.push(...monthPayload);
    });

    return formattedAnswers;
  };

  const buildEmployeeDetailTripPayload = (sourceAnswers = answers) => {
    return buildGenericTripBranchingPayload(sourceAnswers, {
      prefix: "employee_detail_",
      division: "workplace_information_no_divison",
      rootQids: ["total_number_of_trip", "type_of_business"],
      branches: [
        {
          countQid: "number_of_trip_individual",
          branchId: "individual_business_travel",
        },
        { countQid: "number_of_trip_group", branchId: "group_business_travel" },
      ],
      tripChildQids: [
        "type_of_trip",
        "mode_transportation",
        "air_travel_type",
        "rail_travel_type",
        "maritime_travel_type",
        "road_travel_type",
        "business_travel_returnmode_same",
        "return_employee_detail_no_selected",
        "return_destination",
        "no_selected",
        "return_employee_detail_air_travel_type",
        "return_employee_detail_rail_travel_type",
        "return_employee_detail_maritime_travel_type",
        "return_employee_detail_road_travel_type",
      ],
    });
  };

  // ============================================================================
  // MAIN buildFinalPayload FUNCTION
  // ============================================================================
  const buildFormattedAnswers = (sourceAnswers = answers) => {
    let formattedAnswers = [];

    const isEmployeeDetail = questionsList.some((q) =>
      q.questionId.startsWith("employee_detail_"),
    );

    // 1. PRIORITY: Run specialized builders for complex structures
    if (subSectionId === "business_travel") {
      formattedAnswers = buildBusinessTravelSubsectionPayload(sourceAnswers);
    } else if (isEmployeeDetail) {
      formattedAnswers = buildEmployeeDetailTripPayload(sourceAnswers);
    }

    // 2. FILL: Standard processing for all questions in the list
    const isPlainPayloadObject = (value) =>
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      !(value instanceof File);

    // Helper to process a single key-value pair from state
    const processAnswer = (qid, key, val) => {
      const q = questionsList.find((q) => q.questionId === qid);
      if (!q) return;

      let divisionId = "no division";
      if (divisionGroups && divisionGroups.length > 0) {
        const division = divisionGroups.find((d) =>
          d.questions.some((dq) => dq.questionId === qid),
        );
        if (division) {
          divisionId = division.divisionId || division._id;
        }
      }

      const tripMatch = key.match(/_trip_(\d+)/);
      let tripIndex = tripMatch ? parseInt(tripMatch[1]) : null;
      let optionValue = null;

      if (key !== qid) {
        if (tripMatch) {
          const afterTrip = key.substring(
            key.indexOf(`_trip_${tripIndex}_`) + `_trip_${tripIndex}_`.length,
          );
          if (afterTrip) optionValue = afterTrip;
        } else {
          optionValue = key.substring(qid.length + 1);
        }
      }

      // --- MULTISELECT DEPENDENCY CHECK ---
      const fallbackMultiselectTriggerId = q.displayCondition?.find(
        (condition) => {
          if (condition.operator !== "exists") return false;
          const triggerQuestion = questionsList.find(
            (question) => question.questionId === condition.triggerQuestionId,
          );
          return triggerQuestion?.questionType === "multiselect";
        },
      )?.triggerQuestionId;

      const multiselectTriggerId =
        getMultiselectDependency(q, sourceAnswers, tripIndex, optionValue) ||
        fallbackMultiselectTriggerId;

      if (
        multiselectTriggerId &&
        (q.questionType === "number" ||
          q.questionType === "text" ||
          q.questionType === "percentage") &&
        !tripIndex
      ) {
        if (!consolidatedQids.has(qid)) {
          const payload = buildMultiselectDependentNumberPayload(
            qid,
            q.questionType,
            multiselectTriggerId,
            sourceAnswers,
          );
          if (payload) {
            formattedAnswers.push({ ...payload, division: divisionId });
          }
          consolidatedQids.add(qid);
        }
        return;
      }

      if (val === undefined || val === null || val === "") return;

      if (q.questionType === "table") {
        const tableData = val;
        const tableDef = tableDefs[qid];
        const payload = buildStandardTablePayload(qid, tableData, tableDef);
        if (payload) {
          formattedAnswers.push({
            ...payload,
            tripIndex,
            optionValue,
            division: divisionId,
          });
        }
      } else {
        if (isPlainPayloadObject(val)) return;
        const numericVal = Number(val);
        const isExplicitNumber =
          q.questionType === "number" || q.questionType === "percentage";
        const isImplicitNumber =
          !isNaN(numericVal) &&
          (key.includes("quantity") ||
            key.includes("percentage") ||
            key.includes("amount") ||
            key.includes("value") ||
            key.includes("number") ||
            (q.questionText || "").toLowerCase().includes("percentage") ||
            (q.questionText || "").toLowerCase().includes("quantity"));

        formattedAnswers.push({
          questionId: stripLoopTokenFromId(qid),
          questionType: q.questionType,
          value:
            isExplicitNumber || isImplicitNumber
              ? isNaN(numericVal)
                ? 0
                : numericVal
              : val,
          optionValue: optionValue,
          tripIndex: tripIndex,
          division: divisionId,
        });
      }
    };

    // Track already handled root questions (for standard questions and consolidation)
    const handledQids = new Set(formattedAnswers.map((a) => a.questionId));

    // Add base IDs of month-suffixed handled questions to prevent the sweep from picking them up again
    formattedAnswers.forEach((a) => {
      const baseMatch = a.questionId.match(
        /^(.*?)_(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i,
      );
      if (baseMatch) handledQids.add(baseMatch[1]);
    });

    if (subSectionId === "business_travel") {
      const businessTravelKeys = [
        "total_number_of_trip",
        "month_trip",
        "type_of_business",
        "business_travel_returnmode_same",
        "return_no_selected",
        "return_destination",
        "no_selected",
        "number_of_trip_individual",
        "number_of_trip_group",
        "type_of_trip",
        "mode_transportation",
        "air_travel_type",
        "rail_travel_type",
        "maritime_travel_type",
        "road_travel_type",
        "return_air_travel_type",
        "return_rail_travel_type",
        "return_maritime_travel_type",
        "return_road_travel_type",
      ];
      businessTravelKeys.forEach((k) => {
        handledQids.add(k);
        // Also add month-suffixed versions just in case they are in the questions list
        const months = [
          "jan",
          "feb",
          "mar",
          "apr",
          "may",
          "jun",
          "jul",
          "aug",
          "sep",
          "oct",
          "nov",
          "dec",
        ];
        months.forEach((m) => handledQids.add(`${k}_${m}`));
      });
    }

    const consolidatedQids = new Set(); // For multiselect-dependent consolidation
    const allQids = questionsList.map((item) => item.questionId);

    // Global Sweep: Process any question from the list that wasn't handled by priority builders
    questionsList.forEach((q) => {
      const qid = q.questionId;
      if (handledQids.has(qid)) return;

      // Find ALL keys in state related to this question (root and suffixed)
      const relatedKeys = Object.keys(sourceAnswers).filter((key) => {
        if (key === qid) return true;

        const isPrefix =
          key.startsWith(`${qid}_`) || key.startsWith(`${qid}${SUFFIX_SEP}`);
        if (!isPrefix) return false;

        // Check if another longer questionId in questionsList matches this key better
        const hasLongerMatchingQid = allQids.some(
          (otherQid) =>
            otherQid !== qid &&
            otherQid.length > qid.length &&
            (key === otherQid ||
              key.startsWith(`${otherQid}_`) ||
              key.startsWith(`${otherQid}${SUFFIX_SEP}`)),
        );

        return !hasLongerMatchingQid;
      });

      relatedKeys.forEach((key) => {
        const val = sourceAnswers[key];
        if (val === undefined || val === null || val === "") return;

        // --- SPECIAL CONSOLIDATION CHECK ---
        // For multiselect-dependent numbers/text, we process the root ID ONCE
        // and its internal logic (buildMultiselectDependentNumberPayload) will handle siblings.
        const isPotentialConsolidated =
          q.questionType === "number" ||
          q.questionType === "text" ||
          q.questionType === "percentage";

        if (isPotentialConsolidated) {
          if (consolidatedQids.has(qid)) return;
          processAnswer(qid, key, val);
          consolidatedQids.add(qid);
        } else {
          // For tables and other non-consolidated types, process each instance individually
          processAnswer(qid, key, val);
        }
      });
    });

    return formattedAnswers;
  };

  const buildFinalPayload = (formattedAnswers) => {
    const getSubsectionStateKey = (targetSectionId, targetSubSectionId) =>
      `${targetSectionId || ""}:::${targetSubSectionId || ""}`;

    const isPlainObject = (value) =>
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      !(value instanceof File);

    const isEmptyPayloadValue = (value) => {
      if (value === undefined || value === null || value === "") return true;
      if (Array.isArray(value)) return value.length === 0;
      if (isPlainObject(value)) return Object.keys(value).length === 0;
      return false;
    };

    const hasMeaningfulTableRowValues = (tableRows = []) =>
      tableRows.some((row) => {
        const rowValues = row?.values || {};
        return Object.values(rowValues).some((value) => {
          if (Array.isArray(value)) {
            return value.length > 0;
          }

          if (isPlainObject(value)) {
            return Object.keys(value).length > 0;
          }

          return value !== undefined && value !== null && value !== "";
        });
      });

    const isMeaningfulAnswer = (answer) => {
      if (!answer || !answer.questionId) return false;

      if (answer.questionType === "table") {
        return hasMeaningfulTableRowValues(answer.tableRows || []);
      }

      return !isEmptyPayloadValue(answer.value);
    };

    const filterMeaningfulAnswers = (answers = []) =>
      (answers || []).filter(isMeaningfulAnswer);

    const sanitizeLoopKeysInTableValue = (value) => {
      if (Array.isArray(value)) {
        const sanitizedArray = value.map((item) =>
          sanitizeLoopKeysInTableValue(item),
        );

        const isLoopKeyValueArray =
          sanitizedArray.length > 0 &&
          sanitizedArray.every(
            (item) =>
              isPlainObject(item) &&
              Object.prototype.hasOwnProperty.call(item, "key") &&
              Object.prototype.hasOwnProperty.call(item, "value"),
          ) &&
          sanitizedArray.every((item) =>
            /^loop_\d+$/.test(String(item.key || "")),
          );

        if (isLoopKeyValueArray) {
          if (sanitizedArray.length === 1) {
            return sanitizeLoopKeysInTableValue(sanitizedArray[0].value);
          }

          return sanitizedArray.map((item) =>
            sanitizeLoopKeysInTableValue(item.value),
          );
        }

        return sanitizedArray;
      }

      if (!isPlainObject(value)) {
        return value;
      }

      return Object.entries(value).reduce((acc, [rawKey, rawVal]) => {
        const sanitizedKey = rawKey.replace(/_loop_\d+$/g, "");
        const sanitizedValue = sanitizeLoopKeysInTableValue(rawVal);

        if (!(sanitizedKey in acc)) {
          acc[sanitizedKey] = sanitizedValue;
          return acc;
        }

        const existingValue = acc[sanitizedKey];

        if (
          isEmptyPayloadValue(existingValue) &&
          !isEmptyPayloadValue(sanitizedValue)
        ) {
          acc[sanitizedKey] = sanitizedValue;
          return acc;
        }

        if (isPlainObject(existingValue) && isPlainObject(sanitizedValue)) {
          acc[sanitizedKey] = sanitizeLoopKeysInTableValue({
            ...existingValue,
            ...sanitizedValue,
          });
        }

        return acc;
      }, {});
    };

    const sanitizeLoopKeysInAnswers = (answers = []) =>
      answers.map((answer) => {
        if (
          answer?.questionType !== "table" ||
          !Array.isArray(answer?.tableRows)
        ) {
          return answer;
        }

        return {
          ...answer,
          tableRows: answer.tableRows.map((row) => ({
            ...row,
            values: sanitizeLoopKeysInTableValue(row.values || {}),
          })),
        };
      });

    const reshapePurchasedGoodsTablePayload = (answers = []) =>
      answers.map((answer) => {
        if (
          (answer?.questionId !== "scope3_purchased_good_yes" &&
            answer?.questionId !== "scope3_purchased_good_no") ||
          answer?.questionType !== "table" ||
          !Array.isArray(answer?.tableRows)
        ) {
          return answer;
        }

        const isNoVariant = answer.questionId === "scope3_purchased_good_no";

        return {
          ...answer,
          tableRows: answer.tableRows.map((row) => {
            const values = { ...(row?.values || {}) };

            // 1. Remove Erroneous Root Category Keys
            const erroneousRootKeys = Object.keys(values).filter(
              (k) =>
                (Array.isArray(values[k]) && !k.endsWith("_details")) ||
                (values[k] === "default" && !k.endsWith("_details")),
            );
            erroneousRootKeys.forEach((k) => delete values[k]);

            // 2. Build percentage_each_category for the 'No' variant
            if (isNoVariant) {
              const detailsKey = Object.keys(values).find((k) =>
                k.endsWith("_details"),
              );
              if (detailsKey && Array.isArray(values[detailsKey])) {
                values[detailsKey] = values[detailsKey].map((detail) => {
                  const newDetail = { ...detail };
                  const multiSelectKey = Object.keys(newDetail).find(
                    (k) =>
                      k.includes("percentage_major_component") &&
                      Array.isArray(newDetail[k]),
                  );

                  if (multiSelectKey) {
                    const selections = newDetail[multiSelectKey];
                    const mapping = selections
                      .map((key) => {
                        const suffixedKey = `${multiSelectKey}_${key}`;
                        const actualKey = Object.keys(newDetail).find(
                          (k) => k === suffixedKey || k.endsWith(`_${key}`),
                        );
                        const val = actualKey ? newDetail[actualKey] : "0";
                        return { key, value: String(val) };
                      })
                      .filter((item) => item.value !== undefined);

                    if (mapping.length > 0) {
                      newDetail["percentage_each_category"] = mapping;
                    }
                  }
                  return newDetail;
                });
              }
            }

            return {
              ...row,
              values,
            };
          }),
        };
      });

    const dedupeAndRemapHeatingEquipmentAnswers = (answers = []) => {
      const dedupedAnswers = [];
      const seenSignatures = new Set();

      answers.forEach((rawAnswer) => {
        if (!rawAnswer || !rawAnswer.questionId) return;

        let answer = rawAnswer;

        if (
          rawAnswer?.questionId === "deatils_of_heating_equipment" &&
          rawAnswer?.questionType === "table" &&
          Array.isArray(rawAnswer?.tableRows)
        ) {
          const shouldUseTable2 = rawAnswer.tableRows.some((row) => {
            const rowValues = row?.values || {};
            return (
              "number_of_units" in rowValues ||
              "category" in rowValues ||
              "fuel_provider_name" in rowValues
            );
          });

          if (shouldUseTable2) {
            answer = {
              ...rawAnswer,
              questionId: "deatils_of_heating_equipment_table2",
            };
          }
        }

        const signature = JSON.stringify({
          questionId: answer.questionId,
          questionType: answer.questionType,
          division: answer.division || null,
          optionValue: answer.optionValue ?? null,
          tripIndex: answer.tripIndex ?? null,
          month: answer.month ?? null,
        });

        if (seenSignatures.has(signature)) {
          return;
        }

        seenSignatures.add(signature);
        dedupedAnswers.push(answer);
      });

      return dedupedAnswers;
    };

    /**
     * Specialized Flattening for power_generator_month_wise_consumption
     * Converts fuel type array to string and ensures flat structure.
     */
    const reshapePowerGeneratorTablePayload = (answers = []) =>
      answers.map((answer) => {
        if (
          answer?.questionId !== "power_generator_month_wise_consumption" ||
          answer?.questionType !== "table" ||
          !Array.isArray(answer?.tableRows)
        ) {
          return answer;
        }

        return {
          ...answer,
          tableRows: answer.tableRows.map((row) => {
            const values = { ...(row?.values || {}) };
            const fuelKey = "power_generator_types_of_fuel";

            // Flatten fuel type array to string
            if (Array.isArray(values[fuelKey]) && values[fuelKey].length > 0) {
              values[fuelKey] = values[fuelKey][0];
            } else if (Array.isArray(values[fuelKey])) {
              values[fuelKey] = ""; // Fallback
            }

            return {
              ...row,
              values,
            };
          }),
        };
      });

    const reshapeStationaryFuelTablePayload = (answers = []) =>
      answers.map((answer) => {
        if (
          answer?.questionType !== "table" ||
          !Array.isArray(answer?.tableRows)
        ) {
          return answer;
        }

        const isAgricultureFuelTable =
          answer?.questionId === "scope1_2_type_of_fuel";
        const isPowerGeneratorTable =
          answer?.questionId === "power_generator_month_wise_consumption";

        if (!isAgricultureFuelTable && !isPowerGeneratorTable) {
          return answer;
        }

        return {
          ...answer,
          tableRows: answer.tableRows.map((row, rowIndex) => {
            const values = { ...(row?.values || {}) };
            const normalizedValues = { ...values };
            const rootKey = isAgricultureFuelTable
              ? "type_of_fuels"
              : "power_generator_types_of_fuel";
            const legacyItemType = values.item_type;
            const rootValue = values[rootKey];

            if (
              isAgricultureFuelTable &&
              Array.isArray(legacyItemType) &&
              legacyItemType.length > 0 &&
              (!Array.isArray(rootValue) || rootValue.length === 0)
            ) {
              normalizedValues[rootKey] = legacyItemType;
            }

            if (
              isPowerGeneratorTable &&
              Array.isArray(legacyItemType) &&
              legacyItemType.length > 0 &&
              (!rootValue || rootValue === "default")
            ) {
              normalizedValues[rootKey] = legacyItemType[0];
            }

            delete normalizedValues.item_type;

            Object.keys(normalizedValues).forEach((key) => {
              const value = normalizedValues[key];
              const lowerKey = key.toLowerCase();
              const shouldBeNumber =
                typeof value !== "object" &&
                value !== "" &&
                value !== null &&
                !isNaN(Number(value)) &&
                (lowerKey.includes("consumption") ||
                  lowerKey.includes("quantity") ||
                  lowerKey.includes("size") ||
                  lowerKey.includes("number") ||
                  lowerKey.includes("amount"));

              if (shouldBeNumber) {
                normalizedValues[key] = Number(value);
              }

              const isBillField = lowerKey.includes("bill");
              if (isBillField && value && !Array.isArray(value)) {
                normalizedValues[key] = [value];
              }
            });

            return {
              ...row,
              rowId: row?.rowId || `row_${rowIndex + 1}`,
              values: normalizedValues,
            };
          }),
        };
      });

    /**
     * Specialized Reshaping for deatils_of_heating_equipment_table2
     * Ensures keys match seeder (name, number_of_units_details) and all fields are nested.
     */
    const reshapeHeatingEquipmentTablePayload = (answers = []) =>
      answers.map((answer) => {
        if (
          answer?.questionId !== "deatils_of_heating_equipment_table2" ||
          answer?.questionType !== "table" ||
          !Array.isArray(answer?.tableRows)
        ) {
          return answer;
        }

        return {
          ...answer,
          tableRows: answer.tableRows.map((row) => {
            const values = { ...(row?.values || {}) };
            const reshapedValues = {};

            // 1. Identify current root category key (the multiselect array)
            let currentCatKey = Object.keys(values).find(
              (k) => Array.isArray(values[k]) && !k.endsWith("_details"),
            );

            if (currentCatKey) {
              reshapedValues["name"] = values[currentCatKey];
            } else {
              // Fallback: look into details to recover selection
              const currentDetailsKey = Object.keys(values).find((k) =>
                k.endsWith("_details"),
              );
              const firstDetail = values[currentDetailsKey]?.[0];
              if (firstDetail) {
                const selectionKey = ["type_of_fuel", "item_type"].find(
                  (k) => firstDetail[k],
                );
                if (selectionKey) {
                  const val = firstDetail[selectionKey];
                  reshapedValues["name"] = Array.isArray(val) ? val : [val];
                }
              }
            }

            // --- SMART SWAP LOGIC ---
            // If 'name' contains a fuel (e.g. natural_gas) and details contain an equipment (e.g. boilers), swap them.
            const equipmentTypes = [
              "boilers",
              "furnaces",
              "heaters",
              "stationary_combustion",
              "boiler",
              "furnace",
              "heater",
            ];
            const currentNameArr = reshapedValues["name"] || [];
            const currentName = currentNameArr[0];

            if (currentName) {
              const currentDetailsKey = Object.keys(values).find((k) =>
                k.endsWith("_details"),
              );
              const rawDetails = Array.isArray(values[currentDetailsKey])
                ? values[currentDetailsKey]
                : [];

              if (rawDetails.length > 0) {
                const firstDetail = rawDetails[0];
                const rawDetailFuelVal =
                  firstDetail["type_of_fuel"] || firstDetail["item_type"];
                const detailFuelVal = Array.isArray(rawDetailFuelVal)
                  ? rawDetailFuelVal[0]
                  : rawDetailFuelVal;

                // If fuel field contains an equipment type, swap it to the root name
                if (
                  detailFuelVal &&
                  equipmentTypes.some((type) =>
                    String(detailFuelVal).includes(type),
                  )
                ) {
                  // Swap: move 'boilers' from detail.type_of_fuel to root.name
                  // and move 'natural_gas' from root.name to detail.type_of_fuel
                  reshapedValues["name"] = Array.isArray(rawDetailFuelVal)
                    ? rawDetailFuelVal
                    : [rawDetailFuelVal];

                  // Update ALL detail entries with the actual fuel from root selection
                  values[currentDetailsKey] = rawDetails.map((d) => ({
                    ...d,
                    type_of_fuel: currentName, // Put 'natural_gas' here (the original root selection)
                  }));
                }
              }
            }

            // 2. Map Repeater Trigger (number_of_units)
            const triggerKey = "number_of_units";
            const unitsVal = values[triggerKey] ?? 0;
            reshapedValues[triggerKey] =
              typeof unitsVal === "number" ? unitsVal : Number(unitsVal) || 0;

            // 3. Collect Details and Nest Everything Else
            const detailsKey = `${triggerKey}_details`;
            const currentDetailsKey = Object.keys(values).find((k) =>
              k.endsWith("_details"),
            );
            const rawDetails = Array.isArray(values[currentDetailsKey])
              ? values[currentDetailsKey]
              : [];

            // Fields that should NOT be pushed into details (they stay at root)
            const rootKeys = [currentCatKey, triggerKey, detailsKey, "name"];

            // Fields currently at root that should have been in details
            const orphanedFields = {};
            Object.keys(values).forEach((k) => {
              if (!rootKeys.includes(k) && k !== currentDetailsKey) {
                orphanedFields[k] = values[k];
              }
            });

            // Reconstruct details array, merging orphaned fields into existing objects if needed
            let finalDetails = rawDetails.map((detail) => ({
              ...detail,
              ...orphanedFields,
            }));

            // If no details exist but orphaned fields do, create a single entry
            if (
              finalDetails.length === 0 &&
              Object.keys(orphanedFields).length > 0
            ) {
              finalDetails = [orphanedFields];
            }

            reshapedValues[detailsKey] = finalDetails;

            return {
              ...row,
              values: reshapedValues,
            };
          }),
        };
      });

    const applyTargetedPayloadFixes = (answers = []) =>
      reshapePowerGeneratorTablePayload(
        reshapeStationaryFuelTablePayload(
          reshapeHeatingEquipmentTablePayload(
            reshapePurchasedGoodsTablePayload(
              dedupeAndRemapHeatingEquipmentAnswers(
                sanitizeLoopKeysInAnswers(answers),
              ),
            ),
          ),
        ),
      );

    const sanitizedFormattedAnswers = filterMeaningfulAnswers(
      applyTargetedPayloadFixes(formattedAnswers),
    );

    const nextPayload = {
      ...payloadState,
      UserId: userId,
      standardFormAllotmentId,
      templateId,
      projectId,
      sectionsData: (payloadState.sectionsData || [])
        .map((section) => ({
          ...section,
          subsectionsData: (section.subsectionsData || [])
            .map((subsection) => {
              const subsectionAnswers = (() => {
                if (
                  section.sectionId === sectionId &&
                  subsection.subSectionId === subSectionId
                ) {
                  return sanitizedFormattedAnswers;
                }

                const subsectionKey = getSubsectionStateKey(
                  section.sectionId,
                  subsection.subSectionId,
                );

                const formattedSubsectionAnswers =
                  formattedAnswersBySubsection[subsectionKey];

                if (formattedSubsectionAnswers) {
                  return filterMeaningfulAnswers(
                    applyTargetedPayloadFixes(formattedSubsectionAnswers),
                  );
                }

                return filterMeaningfulAnswers(subsection.answers || []);
              })();

              return {
                ...subsection,
                answers: subsectionAnswers,
              };
            })
            .filter((subsection) => subsection.answers.length > 0),
        }))
        .filter((section) => section.subsectionsData.length > 0),
    };

    setPayloadState(nextPayload);
    return nextPayload;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!onFormattedAnswersChange) return;
    onFormattedAnswersChange(buildFormattedAnswers(answers));
  }, [answers, questionsList, tableDefs, onFormattedAnswersChange]);

  useEffect(() => {
    return () => {
      if (savePopupTimeoutRef.current) {
        clearTimeout(savePopupTimeoutRef.current);
      }
      if (errorPopupTimeoutRef.current) {
        clearTimeout(errorPopupTimeoutRef.current);
      }
    };
  }, []);

  const validatePayload = (payload) => {
    const errors = [];
    const submittedAnswers =
      payload?.sectionsData
        ?.find((section) => section.sectionId === sectionId)
        ?.subsectionsData?.find(
          (subsection) => subsection.subSectionId === subSectionId,
        )?.answers || [];

    for (const ans of submittedAnswers) {
      const question = questionsList.find(
        (q) => q.questionId === ans.questionId,
      );
      const label = question?.questionText || ans.questionId;
      const isPercentage =
        ans.questionType === "percentage" ||
        String(ans.questionId).toLowerCase().includes("percentage");
      if (isPercentage) {
        if (Array.isArray(ans.value)) {
          // Split categories: Must sum to exactly 100
          const total = ans.value.reduce(
            (sum, item) => sum + (Number(item.value) || 0),
            0,
          );
          if (total !== 0 && Math.abs(total - 100) > 0.1) {
            errors.push(
              `Total percentage for "${label}" must be exactly 100%. Current: ${total}%`,
            );
          }
        } else {
          // Single value: Must be <= 100
          const val = Number(ans.value);
          if (val > 100) {
            errors.push(`Percentage for "${label}" cannot exceed 100%.`);
          }
        }
      }

      // Global Negative Check
      if (typeof ans.value === "number" && ans.value < 0) {
        errors.push(`Negative values are not allowed for "${label}"`);
      }
    }
    return errors;
  };

  const buildFilePayload = (payload) => {
    const filePayload = new FormData();
    let hasFiles = false;
    const addedFiles = new Set();

    payload?.sectionsData?.forEach((section) => {
      section.subsectionsData?.forEach((subsection) => {
        subsection.answers?.forEach((ans) => {
          if (ans.questionType === "file" && Array.isArray(ans.value)) {
            // Condition 1: Normal question without any table or nesting
            ans.value.forEach((file) => {
              if (file instanceof File) {
                const uniqueId = `${ans.questionId}-${file.name}-${file.size}-${file.lastModified}`;
                if (!addedFiles.has(uniqueId)) {
                  filePayload.append(ans.questionId, file);
                  addedFiles.add(uniqueId);
                  hasFiles = true;
                }
              }
            });
          } else if (
            ans.questionType === "table" &&
            Array.isArray(ans.tableRows)
          ) {
            ans.tableRows.forEach((row) => {
              const values = row.values || {};
              Object.entries(values).forEach(([key, val]) => {
                if (key.endsWith("_details") && Array.isArray(val)) {
                  // Condition 2: Inside _details array
                  val.forEach((detailObj, index) => {
                    Object.entries(detailObj).forEach(
                      ([detailKey, detailVal]) => {
                        if (Array.isArray(detailVal)) {
                          detailVal.forEach((file) => {
                            if (file instanceof File) {
                              const appendKey = `${ans.questionId}/${key}/${index}/${detailKey}`;
                              const uniqueId = `${appendKey}-${file.name}-${file.size}-${file.lastModified}`;
                              if (!addedFiles.has(uniqueId)) {
                                filePayload.append(appendKey, file);
                                addedFiles.add(uniqueId);
                                hasFiles = true;
                              }
                            }
                          });
                        }
                      },
                    );
                  });
                } else if (Array.isArray(val)) {
                  // Condition 3: Inside table but no _details array
                  val.forEach((file) => {
                    if (file instanceof File) {
                      const appendKey = `${ans.questionId}/${key}`;
                      const uniqueId = `${appendKey}-${file.name}-${file.size}-${file.lastModified}`;
                      if (!addedFiles.has(uniqueId)) {
                        filePayload.append(appendKey, file);
                        addedFiles.add(uniqueId);
                        hasFiles = true;
                      }
                    }
                  });
                }
              });
            });
          }
        });
      });
    });

    return hasFiles ? filePayload : null;
  };

  const showMandatoryErrorsPopup = (message, errors = []) => {
    if (!Array.isArray(errors) || errors.length === 0) {
      toast.error(
        message || "Please fill all mandatory fields before submitting.",
      );
      return;
    }

    setMandatoryErrorPopup({
      open: true,
      message: message || "Please fill all mandatory fields before submitting.",
      errors,
    });
  };

  const submitForm = async (moveNext = false) => {
    const formattedAnswers = buildFormattedAnswers();
    const payload = buildFinalPayload(formattedAnswers);

    // 1. Pre-submission check (Frontend)
    const validationErrors = validatePayload(payload);
    if (validationErrors.length > 0) {
      validationErrors.forEach((err) => toast.error(err));
      return;
    }

    try {
      const submissionPayload = {
        ...payload,
        isSubmitted: true,
      };

      const formData = buildFilePayload(payload) || new FormData();

      Object.entries(submissionPayload).forEach(([key, value]) => {
        if (typeof value === "object" && value !== null) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      const res = await postApi({
        apiUrl: API_URLS.SAVE_ANSWERS,
        data: formData,
      });

      if (res && res.success) {
        if (savePopupTimeoutRef.current) {
          clearTimeout(savePopupTimeoutRef.current);
        }

        setSavePopup({
          open: true,
          message: res?.message || "Form saved successfully!",
          moveNext,
        });

        savePopupTimeoutRef.current = setTimeout(() => {
          setSavePopup((prev) => ({
            open: false,
            message: "",
            moveNext: false,
          }));

          if (moveNext && onNext) {
            onNext();
          }
        }, 2000);
      } else if (Array.isArray(res?.errors) && res.errors.length > 0) {
        showMandatoryErrorsPopup(res?.message, res.errors);
      } else {
        setErrorPopup({
          open: true,
          title: "Submission Failed",
          message: res?.message || "Could not save your answers.",
        });
      }
    } catch (e) {
      //console.error("Submission Error Log:", e);

      const status = e.response?.status;
      const serverMessage = e.response?.data?.message;

      if (status === 400 && serverMessage) {
        const serverErrors = e.response?.data?.errors;
        if (Array.isArray(serverErrors) && serverErrors.length > 0) {
          showMandatoryErrorsPopup(serverMessage, serverErrors);
        } else {
          setErrorPopup({
            open: true,
            title: "Submission Failed",
            message: serverMessage,
          });
        }
      } else if (status === 500) {
        // Server crashed (Hide the status code 500)
        setErrorPopup({
          open: true,
          title: "Server Error",
          message: "Something went wrong on our end. Please try again later.",
        });
      } else if (!e.response) {
        // Internet is down
        setErrorPopup({
          open: true,
          title: "Submission Failed",
          message:
            "Percentage calculation is not correct or submission failed.",
        });
      } else {
        // Any other weird error
        setErrorPopup({
          open: true,
          title: "Submission Failed",
          message: "Action could not be completed at this time.",
        });
      }
    }
  };

  const saveCurrentSubsectionToPayload = () => {
    const formattedAnswers = buildFormattedAnswers();
    buildFinalPayload(formattedAnswers);
  };

  // Filter for Root Questions
  const rootQuestions = useMemo(() => {
    // 1. Identify all questions that are "children" (i.e. triggered by another question)
    const childIds = new Set();
    questionsList.forEach((q) => {
      if (q.displayCondition && q.displayCondition.length > 0) {
        childIds.add(q.questionId);
      }
    });

    // Return questions that are NOT in the child set
    return questionsList.filter((q) => !childIds.has(q.questionId));
  }, [questionsList]);

  //const numberOfTrips = Math.max(0, (parseInt(answers["number_of_trip_select"]) || 0) - 1);

  const tripDependentQuestions = useMemo(() => {
    return questionsList.filter((q) =>
      q.displayCondition?.some(
        (c) =>
          c.triggerQuestionId === "number_of_trip_select" &&
          c.operator === "exists",
      ),
    );
  }, [questionsList]);

  const tripDependentIds = useMemo(
    () => new Set(tripDependentQuestions.map((q) => q.questionId)),
    [tripDependentQuestions],
  );
  // Add this new useMemo to group questions by division
  const divisionGroups = useMemo(() => {
    if (!questionsProp || !Array.isArray(questionsProp)) return [];

    return questionsProp.map((division) => ({
      divisionId: division.divisionId || division._id,
      divisionTitle: division.divisionTitle || division.name,
      totalQuestions:
        division.totalQuestions ||
        (division.questions ? division.questions.length : 0),
      questions: division.questions || [],
    }));
  }, [questionsProp]);

  // Add this new useMemo to get root questions per division
  const rootQuestionsByDivision = useMemo(() => {
    const childIds = new Set();
    questionsList.forEach((q) => {
      if (q.displayCondition && q.displayCondition.length > 0) {
        childIds.add(q.questionId);
      }
    });

    return divisionGroups.map((division) => ({
      ...division,
      rootQuestions: division.questions.filter(
        (q) => !childIds.has(q.questionId),
      ),
    }));
  }, [divisionGroups, questionsList]);
  //console.log(rootQuestionsByDivision, "rootQuestionsByDivisionrootQuestionsByDivision")
  const [openDivisions, setOpenDivisions] = useState({});

  useEffect(() => {
    if (!Array.isArray(divisionGroups) || divisionGroups.length === 0) {
      setOpenDivisions({});
      return;
    }

    const initialOpenState = {};
    divisionGroups.forEach((_, idx) => {
      initialOpenState[idx] = true;
    });
    setOpenDivisions(initialOpenState);
  }, [divisionGroups]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      {savePopup.open && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4">
          <PopupCard type="success" title="Saved" message={savePopup.message} />
        </div>
      )}
      {submitConfirmPopup &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 99999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.35)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
            }}
          >
            <PopupCard
              type="warning"
              title="Confirm Submission"
              message={`Are you sure you want to submit this form?\n\nOnce submitted, your responses will be recorded, and you will no longer be able to edit this form.`}
              onCancel={() => setSubmitConfirmPopup(false)}
              cancelText="Cancel"
              onConfirm={() => {
                setSubmitConfirmPopup(false);
                submitForm(false);
              }}
              confirmText="Submit Form"
              widthClass="sm:w-[400px]"
            />
          </div>,
          document.body,
        )}
      {errorPopup.open &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 99999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.35)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
            }}
          >
            <PopupCard
              type="error"
              title={errorPopup.title}
              message={errorPopup.message}
            />
          </div>,
          document.body,
        )}
      <MandatoryErrorsModal
        open={mandatoryErrorPopup.open}
        message={mandatoryErrorPopup.message}
        errors={mandatoryErrorPopup.errors}
        sections={sections}
        subsectionsBySection={subsectionsBySection}
        onClose={() =>
          setMandatoryErrorPopup({ open: false, message: "", errors: [] })
        }
      />
      <div className="max-w-4xl mx-auto">
        <div className="space-y-4">
          <div className="space-y-4">
            {divisionGroups.length > 0
              ? (() => {
                  const rootCounter = { current: 0 };

                  return divisionGroups.map((group, idx) => {
                    const isExpanded = !!openDivisions[idx];
                    const groupQuestions =
                      rootQuestionsByDivision[idx]?.rootQuestions || [];

                    return (
                      <div
                        key={group.divisionId || idx}
                        className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setOpenDivisions((prev) => ({
                              ...prev,
                              [idx]: !prev[idx],
                            }))
                          }
                          className={`w-full flex items-center justify-between px-6 py-4 text-left transition-colors duration-200 ${
                            isExpanded ? "bg-teal-50" : "hover:bg-gray-50"
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <span
                              className={`font-semibold text-lg ${isExpanded ? "text-teal-700" : "text-gray-700"}`}
                            >
                              {group.divisionTitle || "No Division"}
                            </span>
                          </div>
                          <svg
                            className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isExpanded ? "transform rotate-180" : ""}`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </button>

                        {isExpanded && (
                          <div className="p-6 border-t border-gray-100 bg-white animate-fadeIn">
                            {groupQuestions.length > 0 ? (
                              groupQuestions.map((q) =>
                                renderQuestion(
                                  q,
                                  0,
                                  null,
                                  null,
                                  null,
                                  "",
                                  false,
                                  rootCounter,
                                ),
                              )
                            ) : (
                              <div className="text-center text-gray-500 py-4">
                                No questions found in this division.
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  });
                })()
              : (() => {
                  const rootCounter = { current: 0 };

                  return rootQuestions.length > 0 ? (
                    rootQuestions.map((q) =>
                      renderQuestion(
                        q,
                        0,
                        null,
                        null,
                        null,
                        "",
                        false,
                        rootCounter,
                      ),
                    )
                  ) : (
                    <div className="bg-white rounded-lg shadow p-6 text-center text-gray-500">
                      No questions found in this section.
                    </div>
                  );
                })()}
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-between">
          {fillFrom ? (
            <>
              <button
                type="button"
                onClick={onPrevious}
                disabled={!canGoPrevious}
                className={`px-6 py-2 rounded-lg font-semibold  ${canGoPrevious ? "border border-[#06513D] text-[#06513D] bg-[#E6EDEB] hover:!bg-[#F8F8F8]" : "cursor-not-allowed border border-gray-200 text-gray-400"}`}
              >
                Previous
              </button>
              <button
                type="button"
                onClick={() => {
                  if (canGoNext) {
                    onNext?.();
                    return;
                  }
                  setSubmitConfirmPopup(true);
                }}
                className="px-6 py-2 bg-[#06513D] text-white hover:bg-[#387464]  rounded-lg  font-semibold"
              >
                {canGoNext ? "Next" : "Save"}
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={onPrevious}
                disabled={!canGoPrevious}
                className={`px-6 py-2 rounded-lg font-semibold ${canGoPrevious ? "border border-[#06513D] text-[#06513D] bg-[#E6EDEB] hover:!bg-[#F8F8F8]" : "cursor-not-allowed border border-gray-200 text-gray-400"}`}
              >
                Previous
              </button>
              <div className="sm:ml-auto">
                <button
                  type="button"
                  onClick={() => {
                    if (canGoNext) {
                      onNext?.();
                    }
                  }}
                  disabled={!canGoNext}
                  className={`px-6 py-2 rounded-lg font-semibold ${
                    canGoNext
                      ? "bg-[#06513D] text-white hover:bg-[#387464]"
                      : "cursor-not-allowed bg-gray-200 text-gray-400"
                  }`}
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
